import { AnyAction, createSlice } from '@reduxjs/toolkit';
import {
  Flight,
  FlightInterface,
  MainProductType,
  Product,
} from './interfaces';
import { flatten, isEmpty, omit } from 'lodash';
import { current } from '@reduxjs/toolkit';
import { PriceView } from '../../hooks/useGetGrossPrice';
import { SubsidizeConfInterface } from '../PackageDetails/packageDataInterface';
import { generateUUID } from './hooks/useHandleCheckout';
import { currencySignsObj } from '@skygroup/shared/utils/constants';
import moment from 'moment';
import {
  CustomerQuestion,
  ParticipantQuestion,
  PriceUnitLabels,
  Questions,
  UnitOption,
} from '../AttractionPage/AttractionTypes';
import getAttractionCommission from '../../utils/getAttractionCommission';
import { UnavailableProductRef } from './collectUnavailableProducts';
import { calculateEvents365CartLineTotal } from '../SportsAndEventsPage/utils/events365LinePricing';
import { packagePriceOption } from '@skygroup/shared/constants/checkoutInfo';
import { convertToTargetCurrencyUtil } from '../../utils/convertEurToUsd';
import {
  calculateCartTotalsUtil,
  calcFlightsTotalUtil,
  computeOneWayPerPaxCommission,
  computeDynamicPackagePerPaxCommission,
  getCartLineCurrency,
} from '../../utils/cartPricing';
import {
  ModelType,
  OrderProductStatus,
  OrderStatus,
  ProductType,
} from '@skygroup/shared/constants/OrderProductConsts';

import {
  DynamicPackageFlightsInfo,
  FlightsInfo,
} from '../../interfaces/flightInterface';
import { TenantTsType } from '@skygroup/shared/constants/tenantTs';
import { Buffer } from 'buffer';
import { ratesInterface } from '../../interfaces';

export interface Transfer {
  id?: any;
  type: MainProductType.transfer;
  date_for_sorting: number;
  from: string;
  to: string;
}
export interface TransferProduct {
  id?: any;
  type: MainProductType.transfer;
  related_guest_indexes: number[];
  product_amount: number;
  transfersArr: Transfer[];
}

export enum PAYMENT_STATUS {
  NEW = 'new',
  FAIL = 'fail',
  SUCCESS = 'success',
  WAITING = 'waiting',
  MISGERET_APPROVED = 'misgeret_approved',
  PARTIAL_PAID = 'partial_paid',
  CANCELED = 'canceled',
  IN_PAYING = 'in_paying',
}

export interface ShoppingCartV2 {
  orderId?: string;
  identifier?: string;
  orderSecret?: string;
  order_status?: OrderStatus;
  order_status_payment?: PAYMENT_STATUS;
  products: Product[];
  isSaved: boolean;
  guests: any[];
  customerInfo: Record<string, string>;
  total_price?: number;
  total_net_price: number;
  totalNumberOfGuests?: number;
  currency_sign: string;
  paid_currency_sign: string;
  prom?: string;
  agency?: { id: string; name: string };
  tp_id?: string;
  affiliate?: string;
  cartNotValid?: boolean;
  /** Refresh-rates failed but the order is still renderable: show the
   *  surviving products and highlight the ones named in `unavailableProducts`
   *  instead of replacing the whole cart with the "not valid" state. */
  hasUnavailableProducts?: boolean;
  unavailableProducts?: UnavailableProductRef[];
  /** `total_price` is the last-known total and still includes the unavailable
   *  products — refresh-rates bailed before re-pricing the order. */
  totalPricePendingRefresh?: boolean;
  appliedSubsidize?: any;
  settings?: any;
  agent_commission?: AgentCommission;
  diamonds?: number;
  redeemedDiamonds?: number[];
  redeemedDiamondsTotal?: number;
  total_diamonds?: any;
  total_price_before_discount?: any;
  autoBookingWorkflowIds?: any;
  /** Travel-agent-bot link — set when the cart was hydrated from a bot session
   *  (?bot_session_id=… on /shopping-cart). Forwarded on order-create so
   *  tbl_orders.bot_session_id records the originating conversation. */
  bot_session_id?: string;
  /** Latest siteConfig.rates snapshot — used for mixed-currency cart totals. */
  exchange_rates?: ratesInterface;
}

/** Agent B2C opened from Backoffice Manage Order to add/replace a
 *  product on an EXISTING order. While set, checkout attaches the cart
 *  products to that order instead of creating a new one. */
export interface AttachToOrderContext {
  order_id: number;
  order_secret: string;
  mode: 'add' | 'replace';
  replaced_order_product_id?: number;
  replaced_product_name?: string;
  customer_name?: string;
  /** Currency the order is priced in, read from the order fetch. The order's
   *  base currency never changes when a product is attached, so cart totals are
   *  pinned to it and the agent is told when the product they picked is priced
   *  in something else. Absent until the order fetch resolves. */
  order_currency_sign?: string;
}

export enum CommissionType {
  Percentage = 'percentage',
  PerPax = 'per_pax',
}
interface AgentCommission {
  commission_per_order: number;
  type: CommissionType;
  per_pax?: number;
  per_pax_currency?: boolean;
  percentage?: number;
}

export interface customerInfo {
  first_name: string;
  last_name: string;
  phone: string;
  email: string;
  comment: string;
  customer_secret: string;
  order_secret: string;
}
interface PaymentFormData {
  transactionId?: string;
  paymentRetries?: number;
}
interface cartSettingsInterface {
  // checkout_info: string;
  // promo_text?: string;
  // hide_flight_from?: boolean;
  // hide_flight_back?: boolean;
  // flight_only?: boolean;
  // info_box?: any;
  // activities_title: string;
  // activities_semi_title: string;
  // price_option_type: packagePriceOption;
  // show_affiliate_info: boolean;
  // show_infants: boolean;
  // show_cancellation_terms: boolean;
  // show_coupon_code: boolean;
  // show_guest_birthday: boolean;
  // show_guest_passport: boolean;
  // is_guest_passport_required: boolean;
  // subsidize_conf:SubsidizeConfInterface
  // infant_price:number
  // show_guest_passport_attachment:boolean
  // is_required_guest_passport_attachment:boolean
  // max_optional_activities:number
  // show_optional_activities:boolean
  // flight_comment: any,
  // rooms_comment: any,
  // is_customer_email_required: boolean;
  // show_order_comment: boolean;
  // guest_icon_to_override_by_text: string;
  // manage_order_back_image: string;
  // show_flights_cart: boolean;
  show_terms: boolean;
  terms_text?: string;
  terms_link?: string;
  // guests_extra_fields: ExtraField[];
  // order_extra_fields: ExtraField[];
  // show_room_filters: boolean;
  // limit_cart_max_rooms:number
  // allow_only_guest_from_subsidize:boolean
  // package_info_as_schedule:boolean
  // show_agency_id:boolean
  // show_docket_id:boolean
  // agencies:Record<string | number, string>
  // redirect?: string,
  // popup_title?: string,
  // popup_content?: string,
}

// Helper to convert event date/time to timestamp
const convertEventDateToTimestamp = (dateStr: string, timeStr: string) => {
  try {
    const [day, month, year] = dateStr.split('/');
    const [hour, minute] = timeStr.split(':');
    const dateObj = new Date(
      parseInt(year),
      parseInt(month) - 1,
      parseInt(day),
      parseInt(hour),
      parseInt(minute)
    );
    return Math.floor(dateObj.getTime() / 1000);
  } catch (error) {
    return moment().unix();
  }
};

const getFlightsFromProducts = (
  shoppingCartV2: ShoppingCartV2,
  staticI: number
) => {
  const products = shoppingCartV2.products[staticI]?.subProducts;

  if (!products?.length) {
    return undefined;
  }

  const arr: any[] = [];

  products?.forEach((product) => {
    if (
      product.type === MainProductType.DynamicPackage &&
      product?.subProducts?.length
    ) {
      const flightPackageProduct = product?.subProducts?.find(
        (subProduct: any) => subProduct.type === MainProductType.Flights
      );
      if (flightPackageProduct?.subProducts?.length) {
        arr.push(...flightPackageProduct?.subProducts);
      }
    } else if (
      product.type === MainProductType.Flights &&
      product?.subProducts?.length
    ) {
      arr.push(...product?.subProducts);
    } else if (
      product.type === MainProductType.Flight ||
      product.type === MainProductType.oneWayFlight
    ) {
      arr.push(product);
    }
  });
  return arr;
};

const initialState: {
  ShoppingCartV2: ShoppingCartV2;
  questions?: any;
  agent_commission: AgentCommission;
  customerInfo: customerInfo;
  orderPriceOption: packagePriceOption;
  paymentFormData: PaymentFormData;
  cartSettings?: cartSettingsInterface;
  attachToOrder?: AttachToOrderContext | null;
  /** Cart-shaped snapshot of the existing order fetched when the
   *  attach flow started. Source for merging the order back into the cart
   *  whenever a product-selection flow resets it (mergeAttachOrderCart). */
  attachOrderSnapshot?: any | null;
} = {
  ShoppingCartV2: {} as ShoppingCartV2,
  attachToOrder: null,
  attachOrderSnapshot: null,
  questions: {
    order_product_id: '',
    questions: {
      customer: [],
      participants: [],
    },
  }, // move it later inside attraction product AvailabilityProductDetails ...
  agent_commission: {
    type: CommissionType.Percentage,
    per_pax: 0,
    // percentage: 7,
    percentage: 5,
  } as AgentCommission,
  customerInfo: {
    first_name: '',
    last_name: '',
    phone: '',
    email: '',
    comment: '',
    order_secret: '',
    customer_secret: '',
  },
  orderPriceOption: '' as packagePriceOption,
  paymentFormData: {} as PaymentFormData,
  cartSettings: {
    show_terms: true,
    terms_link: '/takanon',
  } as cartSettingsInterface,
};

/**
 * Shared, sparse removal of guest indexes after a product/subProduct is deleted.
 *
 * Removes ONLY the given guest indexes from `guests` and from every
 * `related_guest_indexes` across the whole product tree. Surviving guest
 * indexes are left exactly as they are (no re-indexing / shifting), so the
 * cart stays internally consistent: a guest's `g_index` always keeps matching
 * the `related_guest_indexes` that reference it.
 *
 * Supports both `number[]` and `number[][]` (multi-room) shapes. Inner arrays
 * that become empty after pruning are dropped. Must be called with the node
 * already removed from the tree so only survivors are pruned.
 */
const pruneGuestIndexes = (state: any, removedIndexesRaw: any[]) => {
  if (!state?.ShoppingCartV2) {
    return;
  }
  const removed = new Set(flatten(removedIndexesRaw ?? []).map(Number));
  if (removed.size === 0) {
    return;
  }

  // A guest is only really gone when nothing else in the cart holds on to it.
  // Two cases where the removed node's indexes must SURVIVE:
  //  - another product still references the same guest (shared travellers);
  //  - in attach/replace mode, the guest exists in the DB (has an id) — that
  //    mode hydrates the booked order into the cart and relinks the new
  //    product's seats onto the replaced product's real guests, so pruning
  //    them here would delete the customer's guests from the cart and strip
  //    them off the products that are still booked. Outside attach mode this
  //    guard is off, so a saved-order cart keeps pruning exactly as before.
  const stillReferenced = new Set<number>();
  const collectReferences = (node: any) => {
    if (!node || typeof node !== 'object') {
      return;
    }
    flatten(node.related_guest_indexes ?? []).forEach((i: any) =>
      stillReferenced.add(Number(i))
    );
    (node.subProducts ?? []).forEach(collectReferences);
  };
  (state.ShoppingCartV2.products ?? []).forEach(collectReferences);

  const guests: any[] = state.ShoppingCartV2.guests ?? [];
  const protectBookedGuests = !!state.attachToOrder;
  const hasDbId = (guest: any) =>
    guest?.id !== undefined && guest?.id !== null && guest?.id !== '';
  guests.forEach((guest: any) => {
    const index = Number(guest.g_index);
    if (!removed.has(index)) {
      return;
    }
    if (stillReferenced.has(index) || (protectBookedGuests && hasDbId(guest))) {
      removed.delete(index);
    }
  });

  if (removed.size === 0) {
    return;
  }

  state.ShoppingCartV2.guests = guests.filter(
    (guest: any) => !removed.has(Number(guest.g_index))
  );

  const prune = (node: any) => {
    if (!node || typeof node !== 'object') {
      return;
    }
    if (Array.isArray(node.related_guest_indexes)) {
      node.related_guest_indexes = node.related_guest_indexes
        .map((entry: any) =>
          Array.isArray(entry)
            ? entry.filter((i: any) => !removed.has(Number(i)))
            : entry
        )
        .filter((entry: any) =>
          Array.isArray(entry) ? entry.length > 0 : !removed.has(Number(entry))
        );
    }
    if (Array.isArray(node.subProducts)) {
      node.subProducts.forEach(prune);
    }
  };

  state.ShoppingCartV2.products?.forEach(prune);
};

/**
 * Next free guest index to allocate when adding new guests.
 *
 * Returns `max(existing g_index) + 1` rather than `guests.length`, so it stays
 * correct even when the guests array is sparse (has gaps left by a deletion).
 * For a contiguous `0..n-1` cart this equals `guests.length`, so existing
 * add behavior is unchanged; it only differs once gaps exist.
 */
const getNextGuestIndex = (guests: any[]): number => {
  if (!guests || guests.length === 0) {
    return 0;
  }
  return Math.max(...guests.map((guest) => Number(guest.g_index))) + 1;
};

const mergeCartExchangeRates = (
  state: { ShoppingCartV2: ShoppingCartV2 },
  rates?: ratesInterface
) => {
  if (rates && Object.keys(rates).length > 0) {
    state.ShoppingCartV2.exchange_rates = rates;
  }
};

/** Coerce cart product identifiers for reliable remove/filter matching. */
const normalizeProductIdentifier = (
  identifier: unknown
): string | undefined => {
  if (identifier == null) {
    return undefined;
  }
  if (typeof identifier === 'string') {
    return identifier;
  }
  if (typeof identifier === 'object' && 't' in (identifier as object)) {
    return String((identifier as { t: unknown }).t);
  }
  return String(identifier);
};

/**
 * Remove a top-level cart product by identifier (in-draft splice so Immer
 * commits the change). Prunes guests then recalculates totals.
 */
const removeTopLevelCartProduct = (
  state: { ShoppingCartV2: ShoppingCartV2 },
  removeId: string,
  related_guest_indexes: unknown
): boolean => {
  const products = state.ShoppingCartV2?.products;
  if (!products?.length) {
    return false;
  }

  const indexToRemove = products.findIndex(
    (product) => normalizeProductIdentifier(product.identifier) === removeId
  );

  if (indexToRemove < 0) {
    return false;
  }

  products.splice(indexToRemove, 1);
  pruneGuestIndexes(state, related_guest_indexes as number[]);
  calculateTotals(state);
  return true;
};

const calculateTotals = (state: any) => {
  const cart = current(state).ShoppingCartV2;
  // Attach mode hydrates the WHOLE existing order into the cart, so as soon as
  // the agent picks a product priced differently the parts disagree and the
  // total would resolve to the mixed-currency USD fallback — a currency the
  // order is not and will not be priced in. The order's base currency is fixed,
  // so pin the display to it and let the parts convert into it.
  const targetCurrency = current(state).attachToOrder?.order_currency_sign;
  const { gross, net } = calculateCartTotalsUtil({
    products: cart.products,
    cartCurrencySign: cart.currency_sign,
    rates: cart.exchange_rates,
    targetCurrency,
  });

  const totalPriceGross = gross.total;
  const totalPriceNet = net.total;
  state.ShoppingCartV2.currency_sign = gross.currency;

  const totalDiamonds =
    current(state).ShoppingCartV2.products?.reduce(
      (accumulator: number, currentValue: Product) => {
        // return Math.ceil(accumulator + currentValue.total_net_price);
        if (currentValue.diamonds === 0) {
          const subProductsTotalPriceNet =
            currentValue?.subProducts?.reduce(
              (subProductAccumulator: number, subProductValue: Product) => {
                return subProductAccumulator + (subProductValue?.diamonds ?? 0);
              },
              0
            ) ?? 0;
          return accumulator + subProductsTotalPriceNet;
        }
        return accumulator + (currentValue?.diamonds ?? 0);
      },
      0
    ) ?? 0;

  state.ShoppingCartV2.total_price = totalPriceGross;
  state.ShoppingCartV2.total_net_price = totalPriceNet;
  state.ShoppingCartV2.diamonds = totalDiamonds;
};

const initialStateShoppingCart = (
  state: any,
  currency_sign: string,
  paid_currency_sign: string,
  agent_commission_percent_from_api: number,
  agent: any
) => {
  const isShoppingCartEmpty =
    isEmpty(state.ShoppingCartV2) || !state.ShoppingCartV2.orderId;

  const agent_commission_percent =
    agent?.price_view === PriceView.Gross
      ? agent_commission_percent_from_api
      : 0;

  // INITIALIZE SHOPPING CART
  if (isShoppingCartEmpty) {
    if (state.agent_commission) {
      state.agent_commission.percentage = agent_commission_percent;
    }

    state.ShoppingCartV2 = {
      orderId: 'ORDER_ID',
      orderSecret: '',
      currency_sign: currency_sign,
      paid_currency_sign: '₪',
      //paid_currency_sign: paid_currency_sign ?? '₪',
      isSaved: false,
      exchange_rates: state.ShoppingCartV2?.exchange_rates,
      customerInfo: {
        customer_first_name:
          state.ShoppingCartV2.customerInfo?.customer_first_name ?? '',
        customer_last_name:
          state.ShoppingCartV2.customerInfo?.customer_last_name ?? '',
        customer_phone: state.ShoppingCartV2.customerInfo?.customer_phone ?? '',
        customer_email: state.ShoppingCartV2.customerInfo?.customer_email ?? '',
        tp_id: '',
        agency_id: '',
        user_comment: state.ShoppingCartV2.customerInfo?.user_comment ?? '',
      },
      // redeemedDiamonds: [],
      // redeemedDiamondsTotal: 0,
      // discountedDiamondsTotal: 0,
    } as any;

    if (agent) {
      state.ShoppingCartV2.redeemedDiamonds = [];
      state.ShoppingCartV2.redeemedDiamondsTotal = 0;
      state.ShoppingCartV2.discountedDiamondsTotal = 0;
    }
  }
};

const addNewGuests = (
  state: any,
  action: any,
  numberOfAdults: number,
  numberOfChildren: number,
  numberOfInfants: number
) => {
  const prevGuests = state.ShoppingCartV2.guests ?? [];

  const generateGuests = (
    pax: string,
    guestNumber: number,
    startIndex: number
  ) => {
    return Array.from(Array(guestNumber)).map((_, i) => {
      const guest: any = {
        id: '',
        g_index: startIndex + i,
        first_name: '',
        last_name: '',
        gender: '',
        type: pax,
        birthdate: null,
        passport_id: '',
        attachment: '',
      };
      action.payload.packageData?.settings?.guests_extra_fields &&
        action.payload.packageData?.settings?.guests_extra_fields.forEach(
          (field: any) => {
            guest[field.name] = '';
          }
        );

      return guest;
    });
  };

  const startIndexOfChildren = getNextGuestIndex(prevGuests) + numberOfAdults;
  const startIndexOfInfants = startIndexOfChildren + numberOfChildren;

  const newAdultGuests = generateGuests(
    'adult',
    numberOfAdults,
    getNextGuestIndex(prevGuests)
  );
  const newChildGuests = generateGuests(
    'child',
    numberOfChildren,
    startIndexOfChildren
  );
  const newInfantGuests = generateGuests(
    'infant',
    numberOfInfants,
    startIndexOfInfants
  );

  state.ShoppingCartV2.guests = [
    ...prevGuests,
    ...newAdultGuests,
    ...newChildGuests,
    ...newInfantGuests,
  ] as any;

  return { prevGuests, newAdultGuests, newChildGuests, newInfantGuests };
};

const createSubProductTransfer = (
  packageData: any,
  numberOfAdults: number,
  numberOfChildren: number,
  prevGuestIndexes: number[],
  newGuestIndexes: number[]
): null | TransferProduct => {
  // SUB PRODUCT TRANSFER
  if (!packageData?.is_include_transfer) {
    return null;
  }
  const flightFrom = packageData?.flights?.flightFrom;
  const flightBack = packageData?.flights?.flightBack;
  const transfersArr: Transfer[] = [];

  if (flightFrom?.length) {
    const from =
      flightFrom[flightFrom.length - 1]?.to?.name ===
      flightFrom[flightFrom.length - 1]?.to?.code
        ? `Airport (${flightFrom[flightFrom.length - 1]?.to?.code})`
        : flightFrom[flightFrom.length - 1]?.to?.name;
    const to = packageData?.hotel?.name;

    transfersArr.push({
      id: undefined,
      type: MainProductType.transfer,
      date_for_sorting: flightFrom[flightFrom.length - 1]?.arrival_date + 1,
      from,
      to,
    });
  }

  if (flightBack?.length) {
    const from = packageData?.hotel?.name;
    const to =
      flightBack[0]?.from?.name === flightBack[0]?.from?.code
        ? `Airport (${flightBack[0]?.from?.name})`
        : flightBack[0]?.from?.name;

    transfersArr.push({
      id: undefined,
      type: MainProductType.transfer,
      date_for_sorting: flightBack[0]?.departure_date - 1,
      from,
      to,
    });
  }

  return {
    id: undefined,
    type: MainProductType.transfer,
    related_guest_indexes: [...prevGuestIndexes, ...newGuestIndexes],
    product_amount: 1,
    transfersArr,
  };
};
const createSubProductAttraction = (
  activities: any,
  numberOfAdults: number,
  numberOfChildren: number,
  prevGuestIndexes: number[],
  newGuestIndexes: number[]
) => {
  // SUB PRODUCT ATTRACTION
  const subProductAttraction =
    activities?.map((activity: any) => {
      return {
        id: activity.id,
        type: MainProductType.Activity,
        name: activity.name,
        product_amount: numberOfAdults + numberOfChildren,
        product_price: 0,
        total_price: 0,
        total_net_price: 0,
        related_guest_indexes: [...prevGuestIndexes, ...newGuestIndexes],
      };
    }) ?? [];

  return subProductAttraction;
};

const createSubProductFlight = (
  flights: FlightInterface,
  prevGuestIndexes: number[],
  newGuestIndexes: number[],
  numberOfAdults: number,
  numberOfChildren: number
) => {
  const { flightBack, flightFrom, ...flightSharedData } = flights;

  const subProductFlights: any[] = [];
  const related_guest_indexes = [...prevGuestIndexes, ...newGuestIndexes];
  const pax = {
    adult: numberOfAdults,
    child: numberOfChildren,
    infant: 0,
  };

  subProductFlights[0] = {
    id: flightFrom[0].id,
    type: MainProductType.Flight,
    product_amount: numberOfAdults + numberOfChildren,
    product_price: 0,
    total_price: 0,
    total_net_price: 0,
    product_data: { flightFrom, ...flightSharedData, pax },
    subProducts: [],
    related_guest_indexes,
  };

  subProductFlights[1] = {
    id: flightBack[0].id,
    type: MainProductType.Flight,
    product_amount: numberOfAdults + numberOfChildren,
    product_price: 0,
    total_price: 0,
    total_net_price: 0,
    product_data: { flightBack, ...flightSharedData, pax },
    subProducts: [],
    related_guest_indexes,
  };

  return subProductFlights;
};

const createSubProductBundleFlight = (
  flightsInfo: DynamicPackageFlightsInfo,
  prevGuestIndexes: number[],
  newGuestIndexes: number[],
  numberOfAdults: number,
  numberOfChildren: number,
  // pax: Record<string, number>,
  pax?: { adult?: number; child?: number; infant?: number },
  isPartialStub?: boolean
) => {
  const subProductFlights: any[] = [];
  const { flightFrom, flightBack, flights_terms, ...flightSharedData } =
    flightsInfo;
  // When completing partial stub, don't concatenate - newGuestIndexes already references the same guests
  const related_guest_indexes = isPartialStub
    ? newGuestIndexes
    : [...prevGuestIndexes, ...newGuestIndexes];

  subProductFlights[0] = {
    id: flightFrom?.[0].flight_number,
    type: MainProductType.Flight,
    product_amount: numberOfAdults + numberOfChildren,
    product_price: 0,
    total_price: 0,
    total_net_price: 0,
    product_data: { flightFrom, ...flightSharedData },
    subProducts: [],
    related_guest_indexes,
  };
  subProductFlights[1] = {
    id: flightBack?.[0].flight_number,
    type: MainProductType.Flight,
    product_amount: numberOfAdults + numberOfChildren,
    product_price: 0,
    total_price: 0,
    total_net_price: 0,

    product_data: { flightBack, ...flightSharedData },
    subProducts: [],
    related_guest_indexes,
  };

  const date_start = flightFrom[0].departure_date;
  const date_end = !flightBack?.length
    ? flightFrom[0].arrival_date
    : flightBack[flightBack.length - 1].arrival_date;

  const subProductBundleFlight = {
    // id: flightsInfo.identifier,
    identifier: flightsInfo.identifier,
    type: MainProductType.Flights,
    name:
      flightsInfo?.name ||
      `${flightFrom?.[0]?.from?.name} - ${
        flightFrom?.[flightFrom?.length - 1]?.to?.name
      } - ${flightBack?.[flightBack?.length - 1]?.to?.name}`,
    product_amount: numberOfAdults + numberOfChildren,
    product_price: 0,
    total_price: 0,
    total_net_price: 0,
    product_data: { flightsInfo, pax },
    // product_data: {
    //   flightsInfo: omit(flightsInfo, 'flights_terms'),
    //   pax: flight.pax,
    // },
    subProducts: subProductFlights,
    related_guest_indexes,
    date_start: date_start,
    date_end: date_end,
    ts_booking_data: flightsInfo?.ts_booking_data,
  } as any;

  return subProductBundleFlight;
};

const createSubProductRoom = (
  roomData: any,
  newGuestIndexes: number[],
  productPrice: number,
  totalPrice: number,
  room: any,
  infantGuestIndexes: any,
  infantPrice: any
) => {
  const subProductRoom = {
    // Unique per cart instance so duplicate rooms (same book_hash/model_id)
    // can be removed individually. See handleRemoveRoom.
    uuid: generateUUID(),
    id: roomData.id,
    type: MainProductType.Room,
    name: room.name,
    product_amount: 1,
    product_price: productPrice,
    total_price: productPrice,
    total_net_price: productPrice,
    product_data: {
      price: roomData,
      room,
    },
    related_guest_indexes: newGuestIndexes,
    subProducts:
      infantGuestIndexes.length > 0
        ? [
            {
              type: MainProductType.roomInfant,
              product_amount: infantGuestIndexes.length,
              product_price: infantPrice,
              total_price: infantGuestIndexes.length * infantPrice,
              total_net_price: infantGuestIndexes.length * infantPrice,
              related_guest_indexes: infantGuestIndexes,
            },
          ]
        : [],
  } as any;

  return subProductRoom;
};

const createSubProductAttractionTicket = (
  optionPrice: any,
  newGuestIndexes: number[],
  quantityData: any,
  totalCountAndPrice: {
    count: number;
    price: number;
    diamonds?: number;
  }
) => {
  const subProductAttractionTicket = {
    id: optionPrice.id,
    type: MainProductType.AttractionTicket,
    name: optionPrice?.availabilityOptions
      ?.map((el: any) => el.selectedOptionValue)
      .join(' - '),
    date_start:
      moment(optionPrice?.availabilityDate, 'YYYY-MM-DD').utc().valueOf() /
      1000,
    date_end:
      moment(optionPrice?.availabilityDate, 'YYYY-MM-DD').utc().valueOf() /
      1000,
    product_data: {
      productDetails: {
        availability: {
          ...optionPrice,
          unitOptions: optionPrice.unitOptions.map((unitOpt: UnitOption) => {
            return {
              ...unitOpt,
              unitQuantity: quantityData[unitOpt.label].count ?? 0,
            };
          }),
        },
      },
    },
    total_price: totalCountAndPrice?.price ?? 0,
    total_net_price: totalCountAndPrice?.price ?? 0,
    product_price: totalCountAndPrice?.price
      ? totalCountAndPrice.price / totalCountAndPrice.count
      : 0, // TBD
    product_net_price: totalCountAndPrice?.price
      ? totalCountAndPrice.price / totalCountAndPrice.count
      : 0, // TBD
    diamonds: totalCountAndPrice.diamonds,
    product_amount: 1,
    related_guest_indexes: newGuestIndexes,
  } as any;

  return subProductAttractionTicket;
};

const createSubProductEventTicket = (
  event: any,
  ticket: any,
  quantity: number,
  deliveryMethod: any,
  guestIndexes: number[]
) => {
  const productPrice = ticket.price;
  const totalPrice = calculateEvents365CartLineTotal({
    grossPricePerTicket: productPrice,
    quantity,
    deliveryPrice: deliveryMethod?.price || 0,
    serviceFee: ticket?.serviceFee || 0,
  });
  const eventTimestamp = convertEventDateToTimestamp(
    event.dateOfEvent,
    event.timeOfEvent
  );

  const subProductEventTicket = {
    id: ticket.id,
    type: MainProductType.EventTicket,
    name: ticket.categoryName,
    date_start: eventTimestamp,
    date_end: eventTimestamp,
    product_data: {
      eventId: event.id,
      ticketDetails: ticket,
      deliveryMethod: deliveryMethod,
      requiredPurchaseFields: ticket.requiredPurchaseFields,
    },
    total_price: totalPrice,
    total_net_price: totalPrice,
    product_price: productPrice,
    product_net_price: productPrice,
    diamonds: (ticket.diamonds || 0) * quantity,
    product_amount: quantity,
    related_guest_indexes: guestIndexes,
  } as any;

  return subProductEventTicket;
};

// Maps event `requiredPurchaseFields` (API camelCase) to the guest object's
// snake_case keys.
const EVENT_REQUIRED_FIELD_MAP: { [key: string]: string } = {
  birthDate: 'birthdate',
  cityOfBirth: 'city_of_birth',
  nationalityCountryId: 'nationality_country_id',
  passportNumber: 'passport_id',
};

const EVENT_REQUIRED_FIELD_DEFAULTS: { [key: string]: any } = {
  birthdate: null,
  city_of_birth: '',
  nationality_country_id: '',
  passport_id: '',
};

// Returns the snake_case guest fields (with empty defaults) that an event
// ticket's required-purchase fields demand. Used both when generating dedicated
// event guests and when events reuse a room's guests (room+events), so the
// checkout form (GuestFormLineV2) renders the extra inputs in both cases.
export const getEventRequiredGuestFields = (
  ticket: any
): { [key: string]: any } => {
  const requiredFields = ticket?.requiredPurchaseFields;
  const fields: { [key: string]: any } = {};
  if (requiredFields) {
    Object.keys(requiredFields).forEach((key) => {
      if (requiredFields[key] === true && EVENT_REQUIRED_FIELD_MAP[key]) {
        const snakeCaseKey = EVENT_REQUIRED_FIELD_MAP[key];
        fields[snakeCaseKey] = EVENT_REQUIRED_FIELD_DEFAULTS[snakeCaseKey] ?? '';
      }
    });
  }
  return fields;
};

// Helper to process a single event ticket for a dynamic package
// Returns: { subProductEvent, eventGuests, eventGuestIndexes, eventPrice, eventDiamonds }
const processEventTicketForDynamicPackage = ({
  eventTicketData,
  currentGuestsLength,
  rates,
  cartCurrencySign,
}: {
  eventTicketData: {
    eventInfo: any;
    ticket: any;
    quantity: number;
    deliveryMethod: any;
  };
  currentGuestsLength: number;
  cartCurrencySign?: string;
  rates?: ratesInterface;
}) => {
  const {
    eventInfo: event,
    ticket,
    quantity,
    deliveryMethod,
  } = eventTicketData;

  // Generate guests for this event ticket
  const generateEventGuests = (guestNumber: number, startIndex: number) => {
    // Conditionally add fields based on requiredPurchaseFields
    const requiredFields = getEventRequiredGuestFields(ticket);
    return Array.from(Array(guestNumber)).map((_, i) => {
      const guest: any = {
        id: '',
        g_index: startIndex + i,
        first_name: '',
        last_name: '',
        type: 'adult',
        ...requiredFields,
      };

      return guest;
    });
  };

  const eventGuestStartIndex = currentGuestsLength;
  const eventGuests = generateEventGuests(quantity, eventGuestStartIndex);

  // Create event guest indexes array
  const eventGuestIndexes = Array.from(Array(quantity)).map(
    (_, i) => eventGuestStartIndex + i
  );

  const eventTimestamp = convertEventDateToTimestamp(
    event.dateOfEvent,
    event.timeOfEvent
  );

  // Create event ticket sub-product
  const eventTicketSubProduct = createSubProductEventTicket(
    event,
    ticket,
    quantity,
    deliveryMethod,
    eventGuestIndexes
  );

  // Calculate event price
  let ticketPrice = ticket.price || 0;

  if (rates && cartCurrencySign) {
    ticketPrice = convertToTargetCurrencyUtil({
      price: ticket.price,
      curr: ticket.currency,
      targetCurrency: cartCurrencySign,
      rates: rates,
    });
  }

  const eventPrice =
    ticketPrice * quantity +
    (deliveryMethod?.price || 0) +
    (ticket?.serviceFee || 0);
  const eventDiamonds = (ticket.diamonds || 0) * quantity;

  // Create main event sub-product
  const subProductEvent = {
    id: event.id,
    type: MainProductType.Event,
    name: event.name,
    date_start: eventTimestamp,
    date_end: eventTimestamp,
    product_data: {
      ...event,
      ...ticket,
    },
    total_price: eventPrice,
    total_net_price: eventPrice,
    product_price: eventPrice,
    product_net_price: eventPrice,
    diamonds: eventDiamonds,
    product_amount: 1,
    related_guest_indexes: eventGuestIndexes,
    subProducts: [eventTicketSubProduct],
  };

  return {
    subProductEvent,
    eventGuests,
    eventGuestIndexes,
    eventPrice,
    eventDiamonds,
  };
};

// Helper to create event subProduct when reusing existing guest indexes (room+events scenario)
const createEventSubProductForDynamicPackage = (
  eventTicketData: {
    eventInfo: any;
    ticket: any;
    quantity: number;
    deliveryMethod: any;
  },
  guestIndexes: number[]
) => {
  const {
    eventInfo: event,
    ticket,
    quantity,
    deliveryMethod,
  } = eventTicketData;

  const eventTimestamp = convertEventDateToTimestamp(
    event.dateOfEvent,
    event.timeOfEvent
  );

  const eventTicketSubProduct = createSubProductEventTicket(
    event,
    ticket,
    quantity,
    deliveryMethod,
    guestIndexes
  );

  const ticketPrice = ticket.price || 0;
  const eventPrice =
    ticketPrice * quantity +
    (deliveryMethod?.price || 0) +
    (ticket?.serviceFee || 0);
  const eventDiamonds = (ticket.diamonds || 0) * quantity;

  return {
    id: event.id,
    type: MainProductType.Event,
    name: event.name,
    date_start: eventTimestamp,
    date_end: eventTimestamp,
    product_data: {
      ...event,
      ...ticket,
    },
    total_price: eventPrice,
    total_net_price: eventPrice,
    product_price: eventPrice,
    product_net_price: eventPrice,
    diamonds: eventDiamonds,
    product_amount: 1,
    related_guest_indexes: guestIndexes,
    subProducts: [eventTicketSubProduct],
  };
};

function takeLastNItems(array: any, n: number) {
  if (n <= 0) {
    return [];
  }
  return array.slice(-n);
}

const createSubProductHotel = (
  state: any,
  hotel: any,
  totalPrice: number,
  productPrice: number,
  prevGuestIndexes: number[],
  newGuestIndexes: number[],
  subProductRoom: Product[],
  packageIndex?: number | null,
  isPartialStub?: boolean
) => {
  const allHotelSubProducts =
    packageIndex !== null
      ? current(state).ShoppingCartV2.products?.[
          packageIndex ?? -1
        ]?.subProducts?.find(
          (product: any) => product.type === MainProductType.Hotel
        )?.subProducts
      : [];

  const subProductHotel = {
    model_id: hotel.id,
    identifier: hotel.identifiers,
    type: MainProductType.Hotel,
    name: hotel.name,
    product_amount: 1,
    product_price: productPrice,
    total_price: totalPrice,
    total_net_price: totalPrice,
    subProducts: allHotelSubProducts
      ? [...allHotelSubProducts, subProductRoom]
      : [subProductRoom],
    // When completing partial stub, don't concatenate - newGuestIndexes already references the same guests
    related_guest_indexes: isPartialStub
      ? newGuestIndexes
      : [...prevGuestIndexes, ...newGuestIndexes],
  } as any;

  return subProductHotel;
};

export const shoppingCartSlice = createSlice({
  name: 'shoppingCart',
  initialState,
  reducers: {
    applyOrderProductsFromApi: (state, action) => {
      // action.payload expected to be the `products` array from useOrderGetApi response
      const productsFromApi: Product[] = action.payload ?? [];

      // Replace or set products in the cart
      state.ShoppingCartV2.products = productsFromApi as any;

      // Collect cashback-type discount products with ts_type === "-1"
      const redeemedArr = (productsFromApi || [])
        .filter((p: any) => String(p.type) === ProductType.WALLET)
        .map((p: any) => Number(p.total_price) || 0); // values likely negative like -100

      state.ShoppingCartV2.redeemedDiamonds = redeemedArr;

      // Compute the absolute sum of redeemed amounts (we want a positive amount to subtract from totals)
      const redeemedSumAbs = redeemedArr.reduce(
        (acc: number, v: number) => acc + Math.abs(v || 0),
        0
      );

      state.ShoppingCartV2.redeemedDiamondsTotal = redeemedSumAbs;

      // Recalculate totals from products (use existing helper so other total logic remains consistent)
      // calculateTotals(state);

      // Subtract redeemed absolute sum from total_net_price so UI reflects discounted net.
      // state.ShoppingCartV2.total_price = (state.ShoppingCartV2.total_price ?? 0) - redeemedSumAbs;
      // state.ShoppingCartV2.total_net_price = (state.ShoppingCartV2.total_net_price ?? 0) - redeemedSumAbs;
    },

    addPackageToCart: (state, action) => {
      const agent_commission =
        action.payload?.packageData?.agent_additional_info
          ?.suggested_commission ?? 0;
      const agent = action.payload.agent;
      initialStateShoppingCart(
        state,
        action.payload.packageData.currency_sign,
        action.payload.packageData.paid_currency_sign,
        agent_commission,
        agent
      );

      const numberOfAdults = action.payload.roomData.adult ?? 0;
      const numberOfChildren = action.payload.roomData.child ?? 0;
      const numberOfInfants = action.payload.roomData.infant ?? 0;
      const totalNumberOfGuests =
        numberOfAdults + numberOfChildren + numberOfInfants;

      const { prevGuests } = addNewGuests(
        state,
        action,
        numberOfAdults,
        numberOfChildren,
        numberOfInfants
      );

      const packageIndex =
        state.ShoppingCartV2.products?.findIndex((product) => {
          return product.identifier === action.payload.packageData.identifier;
        }) ?? 0;

      const prevGuestIndexes =
        current(state).ShoppingCartV2.products?.[packageIndex]
          ?.related_guest_indexes ?? [];

      const newGuestIndexes = [
        ...Array.from(Array(totalNumberOfGuests)).map(
          (_, i) => getNextGuestIndex(prevGuests) + i
        ),
      ];

      const infantGuestIndexes = takeLastNItems(
        newGuestIndexes,
        numberOfInfants
      );

      const newProductTotalPrice =
        action.payload.roomData.room_price +
        (action.payload.roomData?.infant ?? 0) *
          (action.payload.packageData?.settings?.infant_price ?? 0);
      const newProductDiamonds = action?.payload?.roomData?.diamonds || 0;
      const allSubProducts = current(state).ShoppingCartV2.products?.[
        packageIndex
      ]?.subProducts?.filter((product: any) => product.type !== 'hotel');
      const oldPrice =
        current(state).ShoppingCartV2.products?.[packageIndex]?.total_price ??
        0;
      const oldPriceNet =
        current(state).ShoppingCartV2.products?.[packageIndex]
          ?.total_net_price ?? 0;
      const oldDiamonds =
        current(state).ShoppingCartV2.products?.[packageIndex]?.diamonds ?? 0;
      const priceOfWholePackage = newProductTotalPrice + oldPrice;
      const priceOfWholePackageNet = newProductTotalPrice + oldPriceNet;
      const diamondsOfWholePackage = newProductDiamonds + oldDiamonds;

      const mainProduct = {
        identifier: action.payload.packageData.identifier,
        type: MainProductType.Package,
        name: action.payload.packageData.name,
        date_start: action.payload.packageData.dates.start,
        date_end: action.payload.packageData.dates.end,
        product_data: {
          ...action.payload.packageData,
        },
        related_guest_indexes: [...prevGuestIndexes, ...newGuestIndexes],
        total_price: priceOfWholePackage,
        total_net_price: priceOfWholePackageNet,
        diamonds: diamondsOfWholePackage,
      } as any;
      const isPackageAlreadyAdded = state.ShoppingCartV2.products?.find(
        (product) =>
          product.identifier === action.payload.packageData.identifier
      );
      if (!isPackageAlreadyAdded) {
        const prevProducts = state.ShoppingCartV2.products ?? [];
        state.ShoppingCartV2.products = [...prevProducts, mainProduct];
      }

      // SUB PRODUCT ATTRACTION
      const subProductAttraction = createSubProductAttraction(
        action.payload.packageData.activities,
        numberOfAdults,
        numberOfChildren,
        prevGuestIndexes,
        newGuestIndexes
      );

      const subProductTransfer = createSubProductTransfer(
        action.payload.packageData,
        numberOfAdults,
        numberOfChildren,
        prevGuestIndexes,
        newGuestIndexes
      );

      // SUB PRODUCT FLIGHTS
      const subProductFlights = createSubProductFlight(
        action.payload.packageData.flights,
        prevGuestIndexes,
        newGuestIndexes,
        numberOfAdults,
        numberOfChildren
      );

      // const newProductTotalPrice =
      //   action.payload.roomData.room_price +
      //   (action.payload.roomData.infant ?? 0) *
      //     (action.payload.packageData.settings.infant_price ?? 0);

      // SUB PRODUCT ROOM
      const subProductRoom = createSubProductRoom(
        action.payload.roomData,
        newGuestIndexes,
        action.payload.roomData.room_price,
        newProductTotalPrice,
        action.payload.room,
        infantGuestIndexes,
        action.payload.packageData.settings.infant_price
      );

      // SUB PRODUCT HOTEL
      const subProductHotel = createSubProductHotel(
        state,
        action.payload.packageData.hotel,
        newProductTotalPrice,
        newProductTotalPrice,
        prevGuestIndexes,
        newGuestIndexes,
        subProductRoom,
        packageIndex
      );

      // const allSubProducts = current(state).ShoppingCartV2.products?.[
      //   packageIndex
      // ]?.subProducts?.filter((product: any) => product.type !== 'hotel');

      // const oldPrice =
      //   allSubProducts?.reduce(
      //     (accumulator, currentValue) => accumulator + currentValue.total_price,
      //     0
      //   ) ?? 0;
      // const priceOfWholePackage = newProductTotalPrice + oldPrice;

      const isFlightOrAttractionAdded = allSubProducts?.find((product) => {
        return (
          product.type === MainProductType.Flight ||
          product.type === MainProductType.Activity
        );
      });

      const packageIndexAfterMainProduct =
        state.ShoppingCartV2.products?.findIndex((product) => {
          return product.identifier === action.payload.packageData.identifier;
        }) ?? 0;

      if (state.ShoppingCartV2.products?.[packageIndexAfterMainProduct]) {
        state.ShoppingCartV2.products[packageIndexAfterMainProduct] =
          mainProduct;
      }
      // Update Attractions and Flight PAX and Add Room
      if (!!isFlightOrAttractionAdded) {
        const updatedSubProducts = allSubProducts?.map((product) => {
          if (
            product.type === MainProductType.Flight ||
            product.type === MainProductType.Activity
          ) {
            return {
              ...product,
              product_amount:
                product.product_amount +
                action.payload.roomData.adult +
                action.payload.roomData.child,
              related_guest_indexes: [...prevGuestIndexes, ...newGuestIndexes],
            };
          } else if (product.type === MainProductType.transfer) {
            return {
              ...product,
              product_amount: product.product_amount + 1,
              related_guest_indexes: [...prevGuestIndexes, ...newGuestIndexes],
            };
          }
          return product;
        });

        state.ShoppingCartV2.products[
          packageIndexAfterMainProduct
        ].subProducts = [
          subProductHotel,
          // updatedSubProducts already includes subProductTransfer
          ...(updatedSubProducts as any),
        ] as any;
      } else {
        state.ShoppingCartV2.products[
          packageIndexAfterMainProduct
        ].subProducts = [
          subProductHotel,
          ...(subProductTransfer ? [subProductTransfer] : []),
          ...subProductAttraction,
          ...subProductFlights,
        ] as any;
      }
      // state.ShoppingCartV2.products[packageIndex].total_price =
      //   priceOfWholePackage;
      // state.ShoppingCartV2.products[packageIndex].total_net_price =
      //   priceOfWholePackage;

      // (state.ShoppingCartV2.products[packageIndex].related_guest_indexes = [
      //   ...prevGuestIndexes,
      //   ...newGuestIndexes,
      // ]),
      calculateTotals(state);
    },

    addDynamicPackageToCart: (state, action) => {
      try {
        const rates = action.payload?.rates;
        mergeCartExchangeRates(state, rates);
        const packageData = action.payload?.packageData;
        const event = action.payload?.event;
        const selectedTickets = action.payload?.selectedTickets;
        const flightsData = packageData?.flights;
        const roomData = action.payload?.room;
        const pricingData = action.payload?.pricingData;

        // Events-only branch: handle adding events without room/flight
        if (event && selectedTickets?.length && !roomData) {
          const packageIdentifier = packageData?.identifier;
          const agent = action.payload?.agent;

          if (
            !packageIdentifier ||
            !event ||
            !selectedTickets ||
            selectedTickets.length === 0
          ) {
            return;
          }

          const packageIndex = state.ShoppingCartV2.products?.findIndex(
            (product) => product.identifier === packageIdentifier
          );

          const packageExists = packageIndex !== undefined && packageIndex >= 0;
          let currentGuestsCount =
            current(state).ShoppingCartV2.guests?.length ?? 0;

          const eventSubProducts: any[] = [];
          let totalEventPrice = 0;
          let totalEventDiamonds = 0;
          const allEventGuestIndexes: number[] = [];

          selectedTickets.forEach((eventTicketData: any) => {
            const result = processEventTicketForDynamicPackage({
              cartCurrencySign: state.ShoppingCartV2.currency_sign,
              rates,
              eventTicketData,
              currentGuestsLength: currentGuestsCount,
            });

            state.ShoppingCartV2.guests = [
              ...(current(state).ShoppingCartV2.guests ?? []),
              ...result.eventGuests,
            ] as any;

            eventSubProducts.push(result.subProductEvent);
            totalEventPrice += result.eventPrice;
            totalEventDiamonds += result.eventDiamonds;
            allEventGuestIndexes.push(...result.eventGuestIndexes);

            currentGuestsCount += result.eventGuests.length;
          });

          if (packageExists) {
            const packageProduct =
              current(state).ShoppingCartV2.products[packageIndex];

            const nonEventSubProducts =
              packageProduct.subProducts?.filter(
                (subProduct: any) => subProduct.type !== MainProductType.Event
              ) || [];

            state.ShoppingCartV2.products[packageIndex].subProducts = [
              ...eventSubProducts,
              ...nonEventSubProducts,
            ] as any;

            state.ShoppingCartV2.products[packageIndex].related_guest_indexes =
              [
                ...(packageProduct.related_guest_indexes || []),
                ...allEventGuestIndexes,
              ];

            state.ShoppingCartV2.products[packageIndex].total_price +=
              totalEventPrice;
            state.ShoppingCartV2.products[packageIndex].total_net_price +=
              totalEventPrice;
            state.ShoppingCartV2.products[packageIndex].diamonds =
              (state.ShoppingCartV2.products[packageIndex].diamonds || 0) +
              totalEventDiamonds;

            if (
              state.ShoppingCartV2.products[packageIndex].product_data
                ?.isPartialDynamicPackage
            ) {
              state.ShoppingCartV2.products[
                packageIndex
              ].product_data.isPartialDynamicPackage = false;
            }
          } else {
            const agent_commission =
              event?.agent_additional_info?.suggested_commission ||
              selectedTickets[0]?.ticket?.agent_additional_info
                ?.suggested_commission ||
              getAttractionCommission();
            const lowerCaseCurrCode =
              selectedTickets[0]?.ticket?.currency?.toLowerCase();
            const currency_sign =
              currencySignsObj?.[
                lowerCaseCurrCode as keyof typeof currencySignsObj
              ] ??
              selectedTickets[0]?.ticket?.currency ??
              '$';

            initialStateShoppingCart(
              state,
              currency_sign,
              '₪',
              agent_commission,
              agent
            );

            const partialDPStub: Product = {
              identifier: packageIdentifier,
              type: MainProductType.DynamicPackage,
              name: event.name || 'Dynamic Package + Events',
              date_start: 0,
              date_end: 0,
              product_data: {
                isPartialDynamicPackage: true,
                hasEventContext: true,
                event,
              },
              related_guest_indexes: allEventGuestIndexes,
              subProducts: eventSubProducts,
              total_price: totalEventPrice,
              total_net_price: totalEventPrice,
              product_price: totalEventPrice,
              product_net_price: totalEventPrice,
              product_amount: 1,
              diamonds: totalEventDiamonds,
            };

            const prevProducts = state.ShoppingCartV2.products ?? [];
            state.ShoppingCartV2.products = [...prevProducts, partialDPStub];
          }

          calculateTotals(state);
          return;
        }
        // agent_commission is a room commission =>
        const agent_commission_flight =
          action.payload?.shareB2C?.dp ??
          // packageData?.flights?.agent_additional_info?.suggested_commission ??
          5;
        const agent_commission_room =
          packageData?.agent_additional_info?.suggested_commission ?? 5;

        const agent_commission = Math.min(
          agent_commission_flight,
          agent_commission_room
        );
        const agent = action.payload?.agent;
        const newProductTotalPrice = action.payload?.newProductTotalPrice;
        const listingAlignedPackageTotal =
          action.payload?.listingAlignedPackageTotal;
        const listingAlignedPackageCurrency =
          action.payload?.listingAlignedPackageCurrency;
        const newProductDiamonds = action.payload?.pricingData?.diamonds || 0;

        const flightIdentifier =
          typeof flightsData?.identifier === 'string'
            ? flightsData?.identifier
            : flightsData?.identifier?.t;

        const decodedFlightIdentifier =
          flightIdentifier &&
          JSON.parse(Buffer.from(flightIdentifier, 'base64').toString('utf8'));

        const isAlpFlight = decodedFlightIdentifier?.ts === TenantTsType.ALP;

        const roomWithFreeCancellation =
          pricingData?.free_cancelation_date &&
          moment(pricingData?.free_cancelation_date * 1000).isAfter(moment());

        // Check If Package is already added as a product in cart
        const packageIndexFind = state.ShoppingCartV2.products?.findIndex(
          (product) => product.identifier === packageData.identifier
        );

        const existingPackage =
          packageIndexFind >= 0
            ? current(state).ShoppingCartV2.products?.[packageIndexFind]
            : null;
        const isPackageAlreadyAdded = packageIndexFind >= 0;
        const isPartialStub =
          existingPackage?.product_data?.isPartialDynamicPackage === true;

        if (
          isPackageAlreadyAdded &&
          !isPartialStub &&
          (!isAlpFlight || !roomWithFreeCancellation)
        ) {
          action.payload?.handleErrorFunc && action.payload?.handleErrorFunc();
          return;
        }

        // Check If room is already added as a product in cart
        const getIsRoomAlreadyAdded = () => {
          const matchingPackage = current(state).ShoppingCartV2.products?.find(
            (product) => product.identifier === packageData.identifier
          );

          if (!matchingPackage?.subProducts) return false;

          const hotelSubProduct = matchingPackage.subProducts.find(
            (subProduct) => subProduct.type === MainProductType.Hotel
          );

          if (!hotelSubProduct?.subProducts) return false;

          return hotelSubProduct.subProducts.some(
            (roomProduct) =>
              roomProduct.type === MainProductType.Room &&
              (roomProduct.id === roomData.id ||
                roomProduct.name === roomData.name)
          );
        };

        if (getIsRoomAlreadyAdded()) {
          action.payload?.handleErrorFunc && action.payload?.handleErrorFunc();
          return;
        }

        initialStateShoppingCart(
          state,
          packageData.currency_sign,
          packageData.paid_currency_sign,
          agent_commission,
          agent
        );
        mergeCartExchangeRates(state, rates);

        const roomOnlyPrice =
          pricingData?.room_price +
          (pricingData?.infant ?? 0) *
            (packageData?.settings?.infant_price ?? 0);
        const isMultiRoom = pricingData?.multi_room_guests?.length > 0;
        const multiRoomNumberOfAdults =
          pricingData?.multi_room_guests?.reduce(
            (total: any, room: any) => total + room.adult,
            0
          ) ?? 0;
        const multiRoomNumberOfChildren =
          pricingData?.multi_room_guests?.reduce(
            (total: any, room: any) => total + room.child,
            0
          ) ?? 0;
        const multiRoomNumberOfInfants =
          pricingData?.multi_room_guests?.reduce(
            (total: any, room: any) => total + room.infant,
            0
          ) ?? 0;

        const numberOfAdults =
          (pricingData.adult ?? 0) + multiRoomNumberOfAdults;
        const numberOfChildren =
          (pricingData.child ?? 0) + multiRoomNumberOfChildren;
        const numberOfInfants =
          (pricingData.infant ?? 0) + multiRoomNumberOfInfants;

        const totalNumberOfGuests =
          numberOfAdults + numberOfChildren + numberOfInfants;

        // Only add new guests if NOT completing a partial stub (events already have guests)
        const { prevGuests } = isPartialStub
          ? { prevGuests: current(state).ShoppingCartV2.guests ?? [] }
          : addNewGuests(
              state,
              action,
              numberOfAdults,
              numberOfChildren,
              numberOfInfants
            );

        const packageIndex = packageIndexFind >= 0 ? packageIndexFind : null;

        const prevGuestIndexes =
          packageIndex !== null
            ? current(state).ShoppingCartV2.products?.[packageIndex]
                ?.related_guest_indexes
            : [];

        const combined_multi_room = [
          {
            adult: pricingData.adult,
            child: pricingData.child,
            infant: pricingData.infant,
          },
          ...pricingData.multi_room_guests,
        ];

        // When completing a partial stub, reuse existing guest indexes instead of creating new ones
        const guestIndexStartOffset = isPartialStub
          ? 0
          : getNextGuestIndex(prevGuests);

        const room_related_guest_indexes: any = isMultiRoom
          ? combined_multi_room.map((room: any, roomIndex: number) => {
              const startIndex =
                guestIndexStartOffset +
                combined_multi_room
                  .slice(0, roomIndex)
                  .reduce(
                    (acc: any, currRoom: any) =>
                      acc + currRoom.adult + currRoom.child + currRoom.infant,
                    0
                  );
              const roomGuestIndexes = Array.from(
                Array(room.adult + room.child + room.infant)
              ).map((_, i) => startIndex + i);
              return roomGuestIndexes;
            })
          : Array.from(Array(totalNumberOfGuests)).map(
              (_, i) => guestIndexStartOffset + i
            );

        const newGuestIndexes = [
          ...Array.from(Array(totalNumberOfGuests)).map(
            (_, i) => guestIndexStartOffset + i
          ),
        ];

        // const infantGuestIndexes = takeLastNItems(
        //   newGuestIndexes,
        //   numberOfInfants
        // );

        const allSubProducts =
          packageIndex !== null
            ? current(state).ShoppingCartV2.products?.[
                packageIndex
              ]?.subProducts?.filter((product: any) => product.type !== 'hotel')
            : [];

        const oldPrice =
          packageIndex !== null
            ? current(state).ShoppingCartV2.products?.[packageIndex]
                ?.total_price
            : 0;
        const oldPriceNet =
          packageIndex !== null
            ? current(state).ShoppingCartV2.products?.[packageIndex]
                ?.total_net_price
            : 0;
        const oldDiamonds =
          packageIndex !== null
            ? current(state).ShoppingCartV2.products?.[packageIndex]?.diamonds
            : 0;

        // SUB PRODUCT ATTRACTION
        const subProductAttraction = createSubProductAttraction(
          packageData.activities,
          numberOfAdults,
          numberOfChildren,
          prevGuestIndexes,
          newGuestIndexes
        );

        // SUB PRODUCT ROOM
        const subProductRoom = {
          // Unique per cart instance so duplicate rooms can be removed
          // individually. See handleRemoveRoom.
          uuid: generateUUID(),
          model_id: roomData.id,
          type: MainProductType.Room,
          name: roomData.name,
          product_amount: pricingData?.room_amount || 1,
          product_price: pricingData?.room_price,
          total_price: roomOnlyPrice,
          total_net_price: roomOnlyPrice,
          base_currency_sign:
            packageData?.hotel_currency_sign ?? pricingData?.currency_sign,
          date_start:
            pricingData?.date_range?.start ?? packageData?.dates?.start,
          date_end: pricingData?.date_range?.end ?? packageData?.dates?.end,
          product_data: {
            ...pricingData,
            currency_sign:
              packageData?.hotel_currency_sign ?? pricingData?.currency_sign,
            room: roomData,
            price_hash: pricingData?.price_hash ? pricingData?.price_hash : '',
            pricingInfo: pricingData,
            price: pricingData?.room_price,
          },
          related_guest_indexes: room_related_guest_indexes,

          // // FOR HOTELS AND DYNAMIC PACKAGES hotels we dont attach subProducts to the room!!!
          // // but for regular packages we do!
          // // NO need to add infant sub product, it's already added in the room pricing
          // subProducts:
          //   infantGuestIndexes.length > 0
          //     ? [
          //         {
          //           type: MainProductType.roomInfant,
          //           ................,
          //         },
          //       ]
          //     : [],
        } as any;

        // TODO FOR SHAKO:add commissions to this !!!
        subProductRoom.roomAndFlightPricePerPax = pricingData.adult_price;

        // SUB PRODUCT HOTEL
        const subProductHotel = createSubProductHotel(
          state,
          packageData.hotel,
          roomOnlyPrice,
          roomOnlyPrice,
          prevGuestIndexes,
          newGuestIndexes,
          subProductRoom,
          packageIndex,
          isPartialStub // Pass isPartialStub flag
        );

        const flightPax = subProductHotel.subProducts?.reduce(
          (
            acc: { adult: number; child: number; infant: number },
            curr: any
          ) => {
            let adult = curr.product_data?.adult || 0;
            let child = curr.product_data?.child || 0;
            let infant = curr.product_data?.infant || 0;

            if (
              isMultiRoom &&
              curr.product_data?.multi_room_guests?.length > 0
            ) {
              curr.product_data?.multi_room_guests?.forEach((r: any) => {
                if (!isNaN(Number(r.adult))) {
                  adult += Number(r.adult);
                }
                if (!isNaN(Number(r.child))) {
                  child += Number(r.child);
                }
                if (!isNaN(Number(r.infant))) {
                  infant += Number(r.infant);
                }
              });
            }
            return {
              adult: acc.adult + adult,
              child: acc.child + child,
              infant: acc.infant + infant,
            };
          },
          {
            adult: 0,
            child: 0,
            infant: 0,
          }
        );

        const subProductBundleFlight = createSubProductBundleFlight(
          packageData.flights,
          prevGuestIndexes,
          newGuestIndexes,
          numberOfAdults,
          numberOfChildren,
          flightPax,
          isPartialStub // Pass isPartialStub flag
        );

        // SUB PRODUCT EVENT (Optional) - Support multiple event tickets
        // Use payload events if provided, otherwise use packageData events
        const eventTicketsArr =
          event && selectedTickets?.length
            ? selectedTickets
            : packageData.eventsManagedSeparately
              ? []
              : packageData.eventTickets ||
                (packageData.eventTicket ? [packageData.eventTicket] : []);
        const eventSubProducts: any[] = [];
        let totalEventPrice = 0;
        let totalEventDiamonds = 0;
        const allEventGuestIndexes: number[] = [];

        // Check if events already exist in package (to avoid adding them multiple times)
        const isEventAlreadyInPackage =
          packageIndex !== null
            ? current(state).ShoppingCartV2.products?.[
                packageIndex
              ]?.subProducts?.some(
                (subProduct: any) => subProduct.type === MainProductType.Event
              )
            : false;

        // Only add events if they exist in packageData AND haven't been added yet
        if (eventTicketsArr.length > 0 && !isEventAlreadyInPackage) {
          // When events are added with a room, they should share the room's guests
          // Don't create new guests for events in this case
          const shouldCreateEventGuests = !roomData; // Only create guests if there's no room (events-only scenario)

          let currentGuestsCount =
            current(state).ShoppingCartV2.guests?.length ?? 0;

          eventTicketsArr.forEach((eventTicketData: any) => {
            if (shouldCreateEventGuests) {
              // Events-only: create new guests
              const result = processEventTicketForDynamicPackage({
                eventTicketData,
                currentGuestsLength: currentGuestsCount,
                cartCurrencySign: state.ShoppingCartV2.currency_sign,
                rates,
              });

              // Add event guests to cart
              state.ShoppingCartV2.guests = [
                ...(current(state).ShoppingCartV2.guests ?? []),
                ...result.eventGuests,
              ] as any;

              // Accumulate totals
              eventSubProducts.push(result.subProductEvent);
              totalEventPrice += result.eventPrice;
              totalEventDiamonds += result.eventDiamonds;
              allEventGuestIndexes.push(...result.eventGuestIndexes);

              // Update current guest count for next iteration
              currentGuestsCount += result.eventGuests.length;
            } else {
              // Room+events: reuse room's guest indexes, don't create new guests
              const eventQuantity = eventTicketData.quantity || 1;

              // Use the room's guest indexes for events
              const eventGuestIndexesFromRoom = newGuestIndexes.slice(
                0,
                eventQuantity
              );

              // The reused room guests were generated without the event
              // ticket's required-purchase fields (city_of_birth,
              // nationality_country_id, ...). Merge those fields in so the
              // checkout form renders them — same fields the events-only path
              // adds via generateEventGuests. Existing values win (spread guest
              // last), so only missing fields get their empty default.
              const eventRequiredFields = getEventRequiredGuestFields(
                eventTicketData.ticket
              );
              if (Object.keys(eventRequiredFields).length > 0) {
                state.ShoppingCartV2.guests = (
                  current(state).ShoppingCartV2.guests ?? []
                ).map((guest: any) =>
                  eventGuestIndexesFromRoom
                    .map(Number)
                    .includes(Number(guest.g_index))
                    ? { ...eventRequiredFields, ...guest }
                    : guest
                ) as any;
              }

              // Create event subProduct manually without calling processEventTicketForDynamicPackage
              const subProductEvent = createEventSubProductForDynamicPackage(
                eventTicketData,
                eventGuestIndexesFromRoom
              );

              eventSubProducts.push(subProductEvent);
              totalEventPrice += subProductEvent.total_price || 0;
              totalEventDiamonds += subProductEvent.diamonds || 0;
              allEventGuestIndexes.push(...eventGuestIndexesFromRoom);
            }
          });
        }

        const isFlightOrAttractionAdded = allSubProducts?.find((product) => {
          return (
            product.type === MainProductType.Flight ||
            product.type === MainProductType.Activity
          );
        });

        // Calculate main product totals including event price (match room listing total on first add)
        const canUseListingAligned =
          typeof listingAlignedPackageTotal === 'number' &&
          !Number.isNaN(listingAlignedPackageTotal) &&
          !isPartialStub &&
          oldPrice === 0;
        const packageNewPartsTotal = canUseListingAligned
          ? listingAlignedPackageTotal
          : newProductTotalPrice + totalEventPrice;
        const priceOfWholePackage = packageNewPartsTotal + oldPrice;
        const priceOfWholePackageNet = packageNewPartsTotal + oldPriceNet;
        const priceOfWholePackageDiamonds =
          newProductDiamonds + oldDiamonds + totalEventDiamonds;

        const mainProduct = {
          // identifier: uuidForCombinedOneWay || packageData.identifier,
          identifier: packageData.identifier,
          type: MainProductType.DynamicPackage,
          // model_type: ModelType.dynamic_package,
          name: packageData.name,
          date_start: packageData?.dates?.start,
          date_end: packageData?.dates?.end,
          product_data: {
            ...packageData,
            // Set hasEventContext flag when events are managed separately
            ...(packageData.eventsManagedSeparately
              ? { hasEventContext: true }
              : {}),
            // Clear isPartialDynamicPackage flag if merging with partial stub
            ...(isPartialStub ? { isPartialDynamicPackage: false } : {}),
          },
          // Main product includes all guests: hotel/flight guests + event guests
          // When events share room guests (room+events), don't add allEventGuestIndexes - they duplicate newGuestIndexes
          related_guest_indexes:
            eventSubProducts.length > 0 && roomData
              ? [...prevGuestIndexes, ...newGuestIndexes]
              : eventSubProducts.length > 0
                ? [
                    ...prevGuestIndexes,
                    ...newGuestIndexes,
                    ...allEventGuestIndexes,
                  ]
                : isPartialStub && existingPackage?.related_guest_indexes
                  ? existingPackage.related_guest_indexes // Reuse existing guest indexes (events already added them)
                  : [...prevGuestIndexes, ...newGuestIndexes],
          total_price: priceOfWholePackage,
          total_net_price: priceOfWholePackageNet,
          diamonds: priceOfWholePackageDiamonds,
          base_currency_sign:
            listingAlignedPackageCurrency ?? packageData.currency_sign,
        } as any;

        if (!isPackageAlreadyAdded) {
          const prevProducts = state.ShoppingCartV2.products ?? [];
          state.ShoppingCartV2.products = [...prevProducts, mainProduct];
        }

        // TODO for SHAKO:
        // This logic comes from the old code for addPackageToCart
        // but it seems to be wrong, and find what it does and why!
        // const packageIndexAfterMainProductFind =
        const packageIndexAfterMainProduct =
          state.ShoppingCartV2.products?.findIndex((product) => {
            return product.identifier === packageData.identifier;
          }) ?? 0;

        // const packageIndexAfterMainProduct =
        //   packageIndexFind >= 0 ? packageIndexFind : 0;
        // This logic comes from the old code for addPackageToCart
        // but it seems to be wrong, and find what it does and why!
        // TODO for SHAKO:

        if (state.ShoppingCartV2.products?.[packageIndexAfterMainProduct]) {
          state.ShoppingCartV2.products[packageIndexAfterMainProduct] =
            mainProduct;
        }
        // Update Attractions and Flight PAX and Add Room
        if (!!isFlightOrAttractionAdded) {
          const updatedSubProducts = allSubProducts?.map((product) => {
            if (
              product.type === MainProductType.Flight ||
              product.type === MainProductType.Activity
            ) {
              return {
                ...product,
                product_amount:
                  product.product_amount + roomData.adult + roomData.child,
                related_guest_indexes: [
                  ...prevGuestIndexes,
                  ...newGuestIndexes,
                ],
              };
            }
            return product;
          });

          // If merging with partial stub, preserve existing Event subProducts
          const existingEventSubProducts =
            isPartialStub && existingPackage?.subProducts
              ? existingPackage.subProducts.filter(
                  (sp: any) => sp.type === MainProductType.Event
                )
              : [];

          state.ShoppingCartV2.products[
            packageIndexAfterMainProduct
          ].subProducts = [
            ...existingEventSubProducts,
            ...eventSubProducts,
            subProductHotel,
            ...(updatedSubProducts as any),
          ] as any;
        } else {
          // If merging with partial stub, preserve existing Event subProducts
          const existingEventSubProducts =
            isPartialStub && existingPackage?.subProducts
              ? existingPackage.subProducts.filter(
                  (sp: any) => sp.type === MainProductType.Event
                )
              : [];

          state.ShoppingCartV2.products[
            packageIndexAfterMainProduct
          ].subProducts = [
            ...existingEventSubProducts,
            ...eventSubProducts,
            subProductHotel,
            subProductBundleFlight,
            ...subProductAttraction,
          ] as any;
        }

        calculateTotals(state);
      } catch {
        // Silent catch
      }
    },

    addTicketToDynamicPackage: (state, action) => {
      try {
        const { packageIdentifier, eventTickets, rates } = action.payload;
        mergeCartExchangeRates(state, rates);
        // Enforce at-least-one-ticket rule
        if (!eventTickets || eventTickets.length === 0) {
          console.warn(
            'Cannot update dynamic package with zero event tickets. At least one ticket is required.'
          );
          return;
        }

        // Find the dynamic package product by identifier
        const packageIndex = state.ShoppingCartV2.products?.findIndex(
          (product) => product.identifier === packageIdentifier
        );

        if (
          packageIndex === null ||
          packageIndex === undefined ||
          packageIndex < 0
        ) {
          console.warn('Dynamic package not found in cart:', packageIdentifier);
          return;
        }

        const packageProduct =
          current(state).ShoppingCartV2.products[packageIndex];

        // Remove all existing event-related subProducts
        const nonEventSubProducts =
          packageProduct.subProducts?.filter(
            (subProduct: any) => subProduct.type !== MainProductType.Event
          ) || [];

        // Get all existing event-related guest indexes
        const existingEventGuestIndexes: number[] = [];
        packageProduct.subProducts?.forEach((subProduct: any) => {
          if (subProduct.type === MainProductType.Event) {
            existingEventGuestIndexes.push(
              ...(subProduct.related_guest_indexes || [])
            );
          }
        });

        // Remove event-related guests
        state.ShoppingCartV2.guests = current(
          state
        ).ShoppingCartV2.guests.filter(
          (guest: any) => !existingEventGuestIndexes.includes(guest.g_index)
        );

        // Get the base guest indexes (hotel/flight guests)
        const baseGuestIndexes = packageProduct.related_guest_indexes.filter(
          (idx: number) => !existingEventGuestIndexes.includes(idx)
        );

        // Process new event tickets
        const eventSubProducts: any[] = [];
        let totalEventPrice = 0;
        let totalEventDiamonds = 0;
        const allNewEventGuestIndexes: number[] = [];
        let currentGuestsCount =
          current(state).ShoppingCartV2.guests?.length ?? 0;

        eventTickets.forEach((eventTicketData: any) => {
          const result = processEventTicketForDynamicPackage({
            eventTicketData,
            currentGuestsLength: currentGuestsCount,
            cartCurrencySign: state.ShoppingCartV2.currency_sign,
            rates,
          });

          // Add event guests to cart
          state.ShoppingCartV2.guests = [
            ...(current(state).ShoppingCartV2.guests ?? []),
            ...result.eventGuests,
          ] as any;

          // Accumulate totals
          eventSubProducts.push(result.subProductEvent);
          totalEventPrice += result.eventPrice;
          totalEventDiamonds += result.eventDiamonds;
          allNewEventGuestIndexes.push(...result.eventGuestIndexes);

          // Update current guest count for next iteration
          currentGuestsCount += result.eventGuests.length;
        });

        // Calculate old totals (excluding events)
        const oldEventPrice =
          packageProduct.subProducts?.reduce((acc: number, subProduct: any) => {
            if (subProduct.type === MainProductType.Event) {
              return acc + (subProduct.total_price || 0);
            }
            return acc;
          }, 0) || 0;

        const oldEventDiamonds =
          packageProduct.subProducts?.reduce((acc: number, subProduct: any) => {
            if (subProduct.type === MainProductType.Event) {
              return acc + (subProduct.diamonds || 0);
            }
            return acc;
          }, 0) || 0;

        // Update the package product
        state.ShoppingCartV2.products[packageIndex].subProducts = [
          ...eventSubProducts,
          ...nonEventSubProducts,
        ] as any;

        state.ShoppingCartV2.products[packageIndex].related_guest_indexes = [
          ...baseGuestIndexes,
          ...allNewEventGuestIndexes,
        ];

        // Update totals
        const priceDelta = totalEventPrice - oldEventPrice;
        const diamondsDelta = totalEventDiamonds - oldEventDiamonds;

        state.ShoppingCartV2.products[packageIndex].total_price += priceDelta;
        state.ShoppingCartV2.products[packageIndex].total_net_price +=
          priceDelta;
        state.ShoppingCartV2.products[packageIndex].diamonds =
          (state.ShoppingCartV2.products[packageIndex].diamonds || 0) -
          oldEventDiamonds +
          totalEventDiamonds;

        calculateTotals(state);
      } catch (error) {
        console.error('Error in addTicketToDynamicPackage:', error);
      }
    },

    updateInfants: (state, action) => {
      const {
        productIndex,
        newNumberOfInfants,
        infantModalIndex,
        infantPrice,
      } = action.payload;

      const findProductByIdentifier = (products: Product[], id: string) =>
        products.find((product) => product.identifier === id);
      const productToUpdate = findProductByIdentifier(
        state.ShoppingCartV2.products,
        productIndex
      );

      if (!productToUpdate) {
        return;
      }

      const roomLevelToUpdate =
        productToUpdate?.subProducts?.[0]?.subProducts?.[infantModalIndex];
      if (!roomLevelToUpdate) {
        return;
      }

      const guestIndexesInfantsOnlyRoomLevel =
        roomLevelToUpdate.subProducts?.[0]?.related_guest_indexes ?? [];
      const guestIndexesWithoutInfantsPackageLevel =
        productToUpdate.related_guest_indexes.filter((gestIndex) => {
          return !guestIndexesInfantsOnlyRoomLevel.includes(gestIndex);
        }) ?? [];
      const guestIndexesWithoutInfantsRoomLevel =
        roomLevelToUpdate.related_guest_indexes.filter((gestIndex) => {
          return !guestIndexesInfantsOnlyRoomLevel.includes(gestIndex);
        }) ?? [];

      const currentInfantCountRoomLevel =
        guestIndexesInfantsOnlyRoomLevel.length;

      state.ShoppingCartV2.guests = current(state).ShoppingCartV2.guests.filter(
        (guest) => !guestIndexesInfantsOnlyRoomLevel.includes(guest.g_index)
      );

      roomLevelToUpdate.related_guest_indexes =
        guestIndexesWithoutInfantsRoomLevel;

      roomLevelToUpdate.subProducts = [];

      productToUpdate.related_guest_indexes =
        guestIndexesWithoutInfantsPackageLevel;
      productToUpdate.subProducts?.map((productToUpdateSubProduct) => {
        productToUpdateSubProduct.related_guest_indexes =
          guestIndexesWithoutInfantsPackageLevel;
      });
      productToUpdate.total_price -= currentInfantCountRoomLevel * infantPrice;
      productToUpdate.total_net_price -=
        currentInfantCountRoomLevel * infantPrice;

      if (newNumberOfInfants > 0) {
        const startIndexOfInfants =
          Math.max(
            ...state.ShoppingCartV2.guests.map((guest) => guest.g_index)
          ) + 1;

        const newInfantGuests = Array.from(
          { length: newNumberOfInfants },
          (_, i) => ({
            id: '',
            g_index: startIndexOfInfants + i,
            first_name: '',
            last_name: '',
            gender: '',
            type: 'infant',
            birthdate: null,
            passport_id: '',
            attachment: '',
          })
        );

        state.ShoppingCartV2.guests.push(...newInfantGuests);

        const newGuestIndexes = newInfantGuests.map((guest) => guest.g_index);

        productToUpdate.related_guest_indexes.push(...newGuestIndexes);

        // productToUpdate.subProducts?.map((x) => {
        //   // x.related_guest_indexes.push(...newGuestIndexes);
        // })
        productToUpdate.total_price += newNumberOfInfants * infantPrice;
        productToUpdate.total_net_price += newNumberOfInfants * infantPrice;

        roomLevelToUpdate.related_guest_indexes.push(...newGuestIndexes);

        roomLevelToUpdate.subProducts.push({
          type: MainProductType.roomInfant,
          product_amount: newNumberOfInfants,
          product_price: infantPrice,
          total_price: newNumberOfInfants * infantPrice,
          total_net_price: newNumberOfInfants * infantPrice,
          related_guest_indexes: newGuestIndexes,
        } as any);
      }
      calculateTotals(state);
    },
    // Add Hotel room to cart
    addHotelToCart: (state, action) => {
      const roomData = action.payload.roomData;
      const roomPricing = action.payload.roomPricing;
      const rates = action.payload.rates;
      const agent_commission =
        roomPricing?.agent_additional_info?.suggested_commission;
      const agent = action.payload.agent;
      initialStateShoppingCart(
        state,
        roomPricing.currency_sign,
        roomPricing.paid_currency_sign,
        agent_commission,
        agent
      );
      mergeCartExchangeRates(state, rates);
      const isMultiRoom = roomPricing?.multi_room_guests?.length > 0;

      const multiRoomNumberOfAdults =
        roomPricing?.multi_room_guests?.reduce(
          (total: any, room: any) => total + room.adult,
          0
        ) ?? 0;
      const multiRoomNumberOfChildren =
        roomPricing?.multi_room_guests?.reduce(
          (total: any, room: any) => total + room.child,
          0
        ) ?? 0;
      const multiRoomNumberOfInfants =
        roomPricing?.multi_room_guests?.reduce(
          (total: any, room: any) => total + room.infant,
          0
        ) ?? 0;

      const numberOfAdults = (roomPricing.adult ?? 0) + multiRoomNumberOfAdults;
      const numberOfChildren =
        (roomPricing.child ?? 0) + multiRoomNumberOfChildren;
      const numberOfInfants =
        (roomPricing.infant ?? 0) + multiRoomNumberOfInfants;

      const totalNumberOfGuests =
        numberOfAdults + numberOfChildren + numberOfInfants;

      const prevGuests = state.ShoppingCartV2.guests ?? [];

      const generateGuests = (
        pax: string,
        guestNumber: number,
        startIndex: number,
        incrementIndex?: () => void
      ) => {
        return Array.from(Array(guestNumber)).map((_, i) => {
          const guest: any = {
            id: '',
            g_index: startIndex + i,
            first_name: '',
            last_name: '',
            gender: '',
            type: pax,
            birthdate: null,
            passport_id: '',
            attachment: '',
          };

          if (incrementIndex) {
            incrementIndex();
          }

          action.payload.hotelInfo?.settings?.guests_extra_fields &&
            action.payload.hotelInfo?.settings?.guests_extra_fields.forEach(
              (field: any) => {
                guest[field.name] = '';
              }
            );

          return guest;
        });
      };

      if (isMultiRoom) {
        const mainRoomGuests = {
          adult: roomPricing.adult,
          child: roomPricing.child,
          infant: roomPricing.infant,
        };
        const allGuestsArr = [
          mainRoomGuests,
          ...roomPricing?.multi_room_guests,
        ];

        let g_index_counter = getNextGuestIndex(prevGuests);
        const incrementIndex = () => {
          g_index_counter++;
        };

        const guests = [...prevGuests];

        allGuestsArr.forEach((g: any, ii: number) => {
          const { adult, child, infant } = g;
          guests.push(
            ...generateGuests('adult', adult, g_index_counter, incrementIndex)
          );
          guests.push(
            ...generateGuests('child', child, g_index_counter, incrementIndex)
          );
          guests.push(
            ...generateGuests('infant', infant, g_index_counter, incrementIndex)
          );
        });

        state.ShoppingCartV2.guests = guests;
      } else {
        const startIndexOfChildren =
          getNextGuestIndex(prevGuests) + numberOfAdults;
        const startIndexOfInfants = startIndexOfChildren + numberOfChildren;

        const newAdultGuests = generateGuests(
          'adult',
          numberOfAdults,
          getNextGuestIndex(prevGuests)
        );
        const newChildGuests = generateGuests(
          'child',
          numberOfChildren,
          startIndexOfChildren
        );
        const newInfantGuests = generateGuests(
          'infant',
          numberOfInfants,
          startIndexOfInfants
        );

        state.ShoppingCartV2.guests = [
          ...prevGuests,
          ...newAdultGuests,
          ...newChildGuests,
          ...newInfantGuests,
        ] as any;
      }

      // Check If Package is already added as a product in out cart
      const isHotelAlreadyAdded = state.ShoppingCartV2.products?.find(
        (product) => product.identifier === action.payload.hotelInfo.identifiers
      );

      const total = 0;
      const mainProductHotel = {
        identifier: action.payload.hotelInfo.identifiers,
        model_id: action.payload.hotelInfo.id,
        type: MainProductType.Hotel,
        name: action.payload.hotelInfo.name,
        product_amount: 0,
        product_price: 0,
        total_price: 0,
        total_net_price: 0,
        diamonds: roomPricing?.diamonds || 0,
        base_currency_sign: roomPricing.currency_sign,
        product_data: {
          currency_sign: roomPricing.currency_sign,
        },
      } as any;

      if (!isHotelAlreadyAdded) {
        const prevProducts = state.ShoppingCartV2.products ?? [];
        state.ShoppingCartV2.products = [...prevProducts, mainProductHotel];
      }

      const newProductTotalPrice =
        roomPricing.room_price +
        (roomPricing.infant ?? 0) *
          (action.payload.hotelInfo?.settings?.infant_price ?? 0);
      const newProductDiamonds = roomPricing?.diamonds || 0;
      const packageIndexTemp =
        state.ShoppingCartV2.products?.findIndex((product) => {
          return product.identifier === action.payload.hotelInfo.identifiers;
        }) ?? 0;

      const prevGuestIndexes =
        current(state).ShoppingCartV2.products?.[packageIndexTemp]
          ?.related_guest_indexes ?? [];

      const combined_multi_room = [
        {
          adult: roomPricing.adult,
          child: roomPricing.child,
          infant: roomPricing.infant,
        },
        ...roomPricing.multi_room_guests,
      ];

      const newGuestIndexes: any = isMultiRoom
        ? combined_multi_room.map((room: any, roomIndex: number) => {
            const startIndex =
              getNextGuestIndex(prevGuests) +
              combined_multi_room
                .slice(0, roomIndex)
                .reduce(
                  (acc: any, currRoom: any) =>
                    acc + currRoom.adult + currRoom.child + currRoom.infant,
                  0
                );
            const roomGuestIndexes = Array.from(
              Array(room.adult + room.child + room.infant)
            ).map((_, i) => startIndex + i);
            return roomGuestIndexes;
          })
        : Array.from(Array(totalNumberOfGuests)).map(
            (_, i) => getNextGuestIndex(prevGuests) + i
          );

      const multiRoomAmount = roomPricing?.multi_room_guests?.every(
        (room: any) => Array.isArray(room)
      )
        ? roomPricing.multi_room_guests.length + 1
        : 1;

      // SUB PRODUCT ROOM
      const subProductRoom = {
        // Unique per cart instance so duplicate rooms can be removed
        // individually. See handleRemoveRoom.
        uuid: generateUUID(),
        model_id: roomData.id,
        type: MainProductType.Room,
        name: roomData.name,
        product_amount: multiRoomAmount,
        product_price: 0,
        total_price: newProductTotalPrice,
        total_net_price: newProductTotalPrice,
        base_currency_sign: roomPricing.currency_sign,
        date_start: roomPricing.date_range.start,
        date_end: roomPricing.date_range.end,
        product_data: {
          ...roomPricing,
          room: roomData,
          price_hash: roomPricing.price_hash ? roomPricing.price_hash : '',
          pricingInfo: roomPricing,
          price: roomPricing,
        },
        related_guest_indexes: newGuestIndexes,
        diamonds: newProductDiamonds,
      } as any;

      const hotelProductIndex = state.ShoppingCartV2.products?.findIndex(
        (product) => {
          return product.identifier === action.payload.hotelInfo.identifiers;
        }
      );

      const prevSubProducts =
        state.ShoppingCartV2.products[hotelProductIndex].subProducts ??
        ([] as any);

      state.ShoppingCartV2.products[hotelProductIndex].subProducts = [
        ...prevSubProducts,
        subProductRoom,
      ] as any;

      // in hotel level we don't need the guests - it's just for the rooms
      // state.ShoppingCartV2.products[hotelProductIndex].related_guest_indexes = [
      //   ...prevGuestIndexes,
      //   ...newGuestIndexes,
      // ];

      state.ShoppingCartV2.products[hotelProductIndex].related_guest_indexes = [
        ...prevGuestIndexes,
        ...(flatten(newGuestIndexes) as any),
      ];

      const totalPrice =
        state.ShoppingCartV2.products[hotelProductIndex].subProducts?.reduce(
          (accumulator, currentValue) => accumulator + currentValue.total_price,
          0
        ) ?? 0;
      const totalDiamonds =
        state.ShoppingCartV2.products[hotelProductIndex].subProducts?.reduce(
          (accumulator, currentValue) =>
            accumulator + (currentValue.diamonds || 0),
          0
        ) ?? 0;
      state.ShoppingCartV2.products[hotelProductIndex].total_price = totalPrice;
      state.ShoppingCartV2.products[hotelProductIndex].total_net_price =
        totalPrice;
      state.ShoppingCartV2.products[hotelProductIndex].diamonds = totalDiamonds;
      state.ShoppingCartV2.products[hotelProductIndex].base_currency_sign =
        roomPricing.currency_sign;

      calculateTotals(state);
    },

    // Add Attraction to cart
    addAttractionToCart: (state, action) => {
      const { attraction, optionPrice, quantityData, agent } = action.payload;
      if (!attraction) {
        return;
      }

      const isAttractionAlreadyAdded = state.ShoppingCartV2.products?.find(
        (product) => product.identifier === attraction.identifier
      );
      // Treat each attraction product (attraction and NOT attraction ticket) as a single pax;
      const numberOfGuests = isAttractionAlreadyAdded ? 0 : 1;
      //

      const attractionIndexInShoppingCart =
        state.ShoppingCartV2.products?.findIndex(
          (product) => product.identifier === attraction.identifier
        ) ?? -1;
      const isTicketAlreadyAdded = state.ShoppingCartV2.products?.[
        attractionIndexInShoppingCart
      ]?.subProducts?.find((product) => product.id === optionPrice.id);

      const agent_commission =
        action.payload.attraction?.agent_additional_info?.suggested_commission;

      const lowerCaseCurrCode = attraction?.priceCurrency?.toLowerCase();
      const currency_sign =
        currencySignsObj?.[
          lowerCaseCurrCode as keyof typeof currencySignsObj
        ] ?? attraction?.priceCurrency;

      initialStateShoppingCart(
        state,
        currency_sign,
        '₪',
        agent_commission ?? getAttractionCommission(), // create a global Const for it and reuse in rendering part (index, info)
        agent
      );

      const totalCountAndPrice = Object.values(quantityData)?.reduce(
        (
          acc: { count: number; price: number; diamonds?: number },
          curr: any
        ) => {
          acc.count += curr.count;
          acc.price += curr.price;
          acc.diamonds += curr.diamonds;
          return acc;
        },
        { count: 0, price: 0, diamonds: 0 }
      );
      const generateGuests = (
        pax: string,
        guestNumber: number,
        startIndex: number
      ) => {
        return Array.from(Array(guestNumber)).map((_, i) => {
          const guest: any = {
            id: '',
            g_index: startIndex + i,
            first_name: '',
            last_name: '',
            gender: '',
            type: pax,
            birthdate: null,
            passport_id: '',
            attachment: '',
          };
          return guest;
        });
      };

      const prevGuests = current(state).ShoppingCartV2.guests ?? [];
      const startIndexOfAdults = getNextGuestIndex(prevGuests);

      const newAdultGuests = generateGuests(
        'adult',
        numberOfGuests,
        startIndexOfAdults
      );

      if (!isTicketAlreadyAdded && attractionIndexInShoppingCart < 0) {
        state.ShoppingCartV2.guests = [...prevGuests, ...newAdultGuests] as any;
      }

      const newGuestIndexes = [
        ...Array.from(Array(numberOfGuests)).map(
          (_, i) => getNextGuestIndex(prevGuests) + i
        ),
      ];

      const currentAttractionRelatedGuestIndex =
        state.ShoppingCartV2.products?.[attractionIndexInShoppingCart]
          ?.related_guest_indexes;

      const prevProducts = state.ShoppingCartV2.products ?? [];
      const subProductAttractionTicket = createSubProductAttractionTicket(
        optionPrice,
        isAttractionAlreadyAdded
          ? currentAttractionRelatedGuestIndex
          : newGuestIndexes,
        quantityData,
        totalCountAndPrice
      );

      if (isAttractionAlreadyAdded) {
        state.ShoppingCartV2.products = state.ShoppingCartV2.products?.map(
          (prod) => {
            if (prod.identifier !== attraction.identifier) {
              return prod;
            }
            let newProd = prod;

            ((newProd.product_data.productInfo.pax = {
              adult:
                newProd.product_data.productInfo.pax.adult + numberOfGuests,
            }),
              (prod.related_guest_indexes = [
                ...prod.related_guest_indexes,
                // ...newGuestIndexes,
              ]));

            if (isTicketAlreadyAdded) {
              // This scenario should be prevented before hand, thus not reaching inside this check
              // but just in case it happens, update/re-write previous ticket with the new ticket attributes:
              return {
                ...newProd,
                subProducts: [
                  ...(prod?.subProducts?.filter(
                    (product) => product.id !== optionPrice.id
                  ) ?? []),
                  subProductAttractionTicket,
                ],
              };
              //
            }

            return {
              ...newProd,
              subProducts: [
                ...(prod?.subProducts ?? []),
                subProductAttractionTicket,
              ],
            };
          }
        );
      } else {
        const mainProductAttraction: Product = {
          id: attraction.id,
          identifier: attraction.identifier,
          type: MainProductType.Attraction,
          name: attraction.title,
          product_data: {
            productInfo: {
              ...attraction,
              pax: {
                adult: numberOfGuests,
              },
            },
          },
          total_price: totalCountAndPrice?.price ?? 0,
          total_net_price: totalCountAndPrice?.price ?? 0,
          diamonds: totalCountAndPrice.diamonds ?? 0,
          product_price: totalCountAndPrice?.price
            ? totalCountAndPrice.price
            : 0, // TBD
          product_net_price: totalCountAndPrice?.price
            ? totalCountAndPrice.price
            : 0, // TBD
          product_amount: 1,
          related_guest_indexes: newGuestIndexes,
          subProducts: [subProductAttractionTicket],
        };

        state.ShoppingCartV2.products = [
          ...prevProducts,
          mainProductAttraction,
        ];
      }

      // // Adds completely new main product:
      // state.ShoppingCartV2.products = [
      //   ...prevProducts,
      //   mainProductAttraction,
      // ];

      const attractionProductIndex = state.ShoppingCartV2.products?.findIndex(
        (product) => {
          return product.identifier === action.payload.attraction.identifier;
        }
      );

      const totalPrice =
        state.ShoppingCartV2.products[
          attractionProductIndex
        ].subProducts?.reduce(
          (accumulator, currentValue) => accumulator + currentValue.total_price,
          0
        ) ?? 0;

      const totalDiamonds =
        state.ShoppingCartV2.products[
          attractionProductIndex
        ].subProducts?.reduce(
          (accumulator, currentValue) =>
            accumulator + (currentValue.diamonds ?? 0),
          0
        ) ?? 0;
      state.ShoppingCartV2.products[attractionProductIndex].total_price =
        totalPrice;
      state.ShoppingCartV2.products[attractionProductIndex].total_net_price =
        totalPrice;
      state.ShoppingCartV2.products[attractionProductIndex].product_price =
        totalPrice;
      state.ShoppingCartV2.products[attractionProductIndex].product_net_price =
        totalPrice;
      state.ShoppingCartV2.products[attractionProductIndex].diamonds =
        totalDiamonds;
      calculateTotals(state);
    },

    // Add Event to cart (Sports & Events tickets)
    addEventToCart: (state, action) => {
      // Multiple ticket selection mode (ACTIVE)
      // Allows users to select different quantities for multiple ticket categories
      // Example: 2 "Short Side" tickets + 3 "Long Side" tickets
      const { event, selectedTickets, agent } = action.payload;
      if (!event || !selectedTickets || selectedTickets.length === 0) {
        return;
      }

      const isEventAlreadyAdded = current(state).ShoppingCartV2.products?.find(
        (product) => product.identifier === event.identifier
      );

      const totalNumberOfTickets = selectedTickets.reduce(
        (sum: number, item: any) => sum + item.quantity,
        0
      );

      const numberOfGuests = totalNumberOfTickets;

      const firstTicket = selectedTickets[0]?.ticket;
      const requiredPurchaseFields =
        selectedTickets[0]?.ticket?.requiredPurchaseFields;

      const generateGuests = (
        pax: string,
        guestNumber: number,
        startIndex: number
      ) => {
        const fieldMapping: { [key: string]: string } = {
          birthDate: 'birthdate',
          cityOfBirth: 'city_of_birth',
          nationalityCountryId: 'nationality_country_id',
          passportNumber: 'passport_id',
        };

        const defaultValues: { [key: string]: any } = {
          birthdate: null,
          city_of_birth: '',
          nationality_country_id: '',
          passport_id: '',
        };

        return Array.from(Array(guestNumber)).map((_, i) => {
          const guest: any = {
            id: '',
            g_index: startIndex + i,
            first_name: '',
            last_name: '',
            type: pax,
          };

          if (requiredPurchaseFields) {
            Object.keys(requiredPurchaseFields).forEach((key) => {
              if (requiredPurchaseFields[key] === true && fieldMapping[key]) {
                const snakeCaseKey = fieldMapping[key];
                guest[snakeCaseKey] = defaultValues[snakeCaseKey] ?? '';
              }
            });
          }

          return guest;
        });
      };

      // attach a new sub-product/ticket to the event and update totals (leaving event object intact)
      if (isEventAlreadyAdded) {
        const prevGuests = current(state).ShoppingCartV2.guests ?? [];
        const startIndexOfGuests = getNextGuestIndex(prevGuests);

        const newGuests = generateGuests(
          'adult',
          numberOfGuests,
          startIndexOfGuests
        );

        state.ShoppingCartV2.guests = [...prevGuests, ...newGuests] as any;

        const newGuestIndexes = [
          ...Array.from(Array(numberOfGuests)).map(
            (_, i) => getNextGuestIndex(prevGuests) + i
          ),
        ];

        let currentGuestIndex = 0;
        const eventTicketSubProducts = selectedTickets.map((item: any) => {
          const ticketGuestIndexes = newGuestIndexes.slice(
            currentGuestIndex,
            currentGuestIndex + item.quantity
          );
          currentGuestIndex += item.quantity;

          return createSubProductEventTicket(
            event,
            item.ticket,
            item.quantity,
            item.deliveryMethod,
            ticketGuestIndexes
          );
        });

        state.ShoppingCartV2.products = state.ShoppingCartV2.products?.map(
          (prod) => {
            if (prod.identifier !== event.identifier) {
              return prod;
            }

            const updatedSubProducts = [...(prod.subProducts ?? [])];

            eventTicketSubProducts.forEach((newSubProduct: Product) => {
              const existingTicketIndex = updatedSubProducts.findIndex(
                (subProd) => subProd.id === newSubProduct.id
              );

              if (existingTicketIndex >= 0) {
                updatedSubProducts[existingTicketIndex] = newSubProduct;
              } else {
                updatedSubProducts.push(newSubProduct);
              }
            });

            return {
              ...prod,
              related_guest_indexes: [
                ...prod.related_guest_indexes,
                ...newGuestIndexes,
              ],
              subProducts: updatedSubProducts,
            };
          }
        );

        const eventProductIndex = state.ShoppingCartV2.products?.findIndex(
          (product) => product.identifier === event.identifier
        );

        if (eventProductIndex !== undefined && eventProductIndex >= 0) {
          const totalPrice =
            state.ShoppingCartV2.products[
              eventProductIndex
            ].subProducts?.reduce(
              (accumulator, currentValue) =>
                accumulator + currentValue.total_price,
              0
            ) ?? 0;

          const totalDiamonds =
            state.ShoppingCartV2.products[
              eventProductIndex
            ].subProducts?.reduce(
              (accumulator, currentValue) =>
                accumulator + (currentValue.diamonds ?? 0),
              0
            ) ?? 0;

          state.ShoppingCartV2.products[eventProductIndex].total_price =
            totalPrice;
          state.ShoppingCartV2.products[eventProductIndex].total_net_price =
            totalPrice;
          state.ShoppingCartV2.products[eventProductIndex].product_price =
            totalPrice;
          state.ShoppingCartV2.products[eventProductIndex].product_net_price =
            totalPrice;
          state.ShoppingCartV2.products[eventProductIndex].diamonds =
            totalDiamonds;
        }

        calculateTotals(state);
        return;
      }

      const eventIndexInShoppingCart =
        state.ShoppingCartV2.products?.findIndex(
          (product) => product.identifier === event.identifier
        ) ?? -1;

      const agent_commission =
        event?.agent_additional_info?.suggested_commission ||
        firstTicket?.agent_additional_info?.suggested_commission ||
        getAttractionCommission();

      const lowerCaseCurrCode = firstTicket?.currency?.toLowerCase();
      const currency_sign =
        currencySignsObj?.[
          lowerCaseCurrCode as keyof typeof currencySignsObj
        ] ?? firstTicket?.currency;

      if (!isEventAlreadyAdded) {
        initialStateShoppingCart(
          state,
          currency_sign,
          '₪',
          agent_commission,
          agent
        );
      }

      // Calculate total count, price, and diamonds across all selected tickets
      const totalCountPriceAndDiamonds = selectedTickets.reduce(
        (
          acc: { count: number; price: number; diamonds: number },
          item: any
        ) => {
          acc.count += item.quantity;
          acc.price +=
            item.ticket.price * item.quantity +
            (item.deliveryMethod?.price || 0) +
            (item.ticket?.serviceFee || 0);
          acc.diamonds += (item.ticket.diamonds || 0) * item.quantity;

          return acc;
        },
        { count: 0, price: 0, diamonds: 0 }
      );

      const prevGuests = current(state).ShoppingCartV2.guests ?? [];
      const startIndexOfGuests = getNextGuestIndex(prevGuests);

      const newGuests = generateGuests(
        'adult',
        numberOfGuests,
        startIndexOfGuests
      );

      if (eventIndexInShoppingCart < 0) {
        state.ShoppingCartV2.guests = [...prevGuests, ...newGuests] as any;
      }

      const newGuestIndexes = [
        ...Array.from(Array(numberOfGuests)).map(
          (_, i) => getNextGuestIndex(prevGuests) + i
        ),
      ];

      // Create sub-products for each ticket category with quantity > 0
      let currentGuestIndex = 0;
      const prevEventTicketSubProducts =
        current(state).ShoppingCartV2.products?.[eventIndexInShoppingCart]
          ?.subProducts ?? [];

      const eventTicketSubProducts = selectedTickets.map((item: any) => {
        const ticketGuestIndexes = newGuestIndexes.slice(
          currentGuestIndex,
          currentGuestIndex + item.quantity
        );
        currentGuestIndex += item.quantity;

        return createSubProductEventTicket(
          event,
          item.ticket,
          item.quantity,
          item.deliveryMethod,
          ticketGuestIndexes
        );
      });

      const eventTimestamp = convertEventDateToTimestamp(
        event.dateOfEvent,
        event.timeOfEvent
      );

      const prevProducts = state.ShoppingCartV2.products ?? [];

      const mainProductEvent: Product = {
        id: event.id,
        identifier: event.identifier || `event-${event.id}`,
        type: MainProductType.Event,
        name: event.name,
        date_start: eventTimestamp,
        date_end: eventTimestamp,
        product_data: {
          ...event,
          ...firstTicket,
        },
        total_price: totalCountPriceAndDiamonds?.price ?? 0,
        total_net_price: totalCountPriceAndDiamonds?.price ?? 0,
        diamonds: totalCountPriceAndDiamonds.diamonds ?? 0,
        product_price: totalCountPriceAndDiamonds?.price
          ? totalCountPriceAndDiamonds.price
          : 0,
        product_net_price: totalCountPriceAndDiamonds?.price
          ? totalCountPriceAndDiamonds.price
          : 0,
        product_amount: 1,
        related_guest_indexes: newGuestIndexes,
        subProducts: eventTicketSubProducts,
      };

      state.ShoppingCartV2.products = [...prevProducts, mainProductEvent];

      calculateTotals(state);
    },

    removeAttractionsFromCart: (state, action) => {
      // Destructure Payload
      const { attractionIdentifier, attractionTicketId } = action.payload;
      const allProducts: any[] = current(state).ShoppingCartV2.products ?? [];
      if (!allProducts?.length) {
        throw new Error('products not found');
      }
      // Find Product Index
      const matchedProductIndex = allProducts.findIndex(
        (product) => product.identifier === attractionIdentifier
      );

      if (
        !allProducts[matchedProductIndex] ||
        allProducts[matchedProductIndex]?.subProducts === undefined
      ) {
        throw new Error('products matching identifier not found');
      }
      // Find Attraction Ticket Index
      const matchedAttractionTicketIndex = allProducts[
        matchedProductIndex
      ].subProducts.findIndex(
        (ticket: any) => ticket.id === attractionTicketId
      );

      if (
        !allProducts[matchedProductIndex].subProducts[
          matchedAttractionTicketIndex
        ]
      ) {
        throw new Error('Attraction Ticket not found');
      }

      // Find Attraction Ticket Guests
      const related_guest_indexes =
        allProducts[matchedProductIndex].subProducts[
          matchedAttractionTicketIndex
        ].related_guest_indexes;

      let updatedAllProducts: any[] = []; // allProducts

      const isLastProduct = allProducts?.length < 2;
      const isLastAttractionTicket =
        allProducts[matchedProductIndex].subProducts?.length < 2;

      if (isLastAttractionTicket && isLastProduct) {
        state.ShoppingCartV2 = {} as any;
        return;
      }
      if (isLastAttractionTicket && !isLastProduct) {
        state.ShoppingCartV2.products.splice(matchedProductIndex, 1);
        pruneGuestIndexes(state, related_guest_indexes);
        calculateTotals(state);
        return;
      }

      updatedAllProducts = allProducts.map((prod) => {
        if (prod.identifier !== attractionIdentifier) {
          return prod;
        }
        return {
          ...prod,
          subProducts: prod.subProducts?.filter(
            (subProd: any) => subProd.id !== attractionTicketId
          ),
        };
      });

      // No need to Update ShoppingCartV2 guests because tickets have shared g_index,
      // thus if its not isLastAttractionTicket no need to update guests
      // state.ShoppingCartV2.guests = updatedGuests;
      // Update ShoppingCartV2 products
      state.ShoppingCartV2.products = updatedAllProducts;

      const totalPrice =
        updatedAllProducts[matchedProductIndex].subProducts?.reduce(
          (accumulator: number, currentValue: Product) => {
            return accumulator + currentValue.total_price;
          },
          0
        ) ?? 0;
      const totalPriceNet =
        updatedAllProducts[matchedProductIndex].subProducts?.reduce(
          (accumulator: number, currentValue: Product) => {
            return accumulator + currentValue.total_net_price;
          },
          0
        ) ?? 0;
      const totalDiamonds =
        updatedAllProducts[matchedProductIndex].subProducts?.reduce(
          (accumulator: number, currentValue: Product) => {
            return accumulator + (currentValue.diamonds ?? 0);
          },
          0
        ) ?? 0;

      state.ShoppingCartV2.products[matchedProductIndex].total_price =
        totalPrice;
      state.ShoppingCartV2.products[matchedProductIndex].total_net_price =
        totalPriceNet;
      state.ShoppingCartV2.products[matchedProductIndex].diamonds =
        totalDiamonds;
      calculateTotals(state);
    },

    removeEventTicketFromCart: (state, action) => {
      // Destructure Payload
      const { eventIdentifier, eventTicketId } = action.payload;
      const products = state.ShoppingCartV2?.products ?? [];
      if (!products?.length) {
        throw new Error('products not found');
      }
      // Find Product Index
      const matchedProductIndex = products.findIndex(
        (product) => product.identifier === eventIdentifier
      );

      if (
        matchedProductIndex < 0 ||
        !products[matchedProductIndex] ||
        products[matchedProductIndex]?.subProducts === undefined
      ) {
        throw new Error('products matching identifier not found');
      }

      const eventProduct = products[matchedProductIndex];

      if (
        !Array.isArray(eventProduct.subProducts) ||
        eventProduct.subProducts.length === 0
      ) {
        throw new Error('Event Ticket subProducts not found');
      } else {
        // Find Event Ticket Index
        const matchedEventTicketIndex = eventProduct.subProducts.findIndex(
          (ticket: any) => ticket.id === eventTicketId
        );

        if (
          matchedEventTicketIndex < 0 ||
          !eventProduct.subProducts[matchedEventTicketIndex]
        ) {
          throw new Error('Event Ticket not found');
        }

        // Find Event Ticket Guests
        const related_guest_indexes =
          eventProduct.subProducts[matchedEventTicketIndex]
            .related_guest_indexes;

        const isLastProduct = products.length < 2;
        const isLastEventTicket = eventProduct.subProducts.length < 2;

        if (isLastEventTicket && isLastProduct) {
          state.ShoppingCartV2 = {} as any;
          return;
        }
        if (isLastEventTicket && !isLastProduct) {
          products.splice(matchedProductIndex, 1);
          pruneGuestIndexes(state, related_guest_indexes);
          calculateTotals(state);
          return;
        }

        // Remove ticket on the Immer draft (not current(state) snapshots) so
        // pruneGuestIndexes can mutate related_guest_indexes on survivors.
        eventProduct.subProducts = eventProduct.subProducts.filter(
          (subProd: any) => subProd.id !== eventTicketId
        );

        pruneGuestIndexes(state, related_guest_indexes);
      }

      const totalPrice =
        eventProduct.subProducts?.reduce(
          (accumulator: number, currentValue: Product) => {
            return accumulator + currentValue.total_price;
          },
          0
        ) ?? 0;
      const totalPriceNet =
        eventProduct.subProducts?.reduce(
          (accumulator: number, currentValue: Product) => {
            return accumulator + currentValue.total_net_price;
          },
          0
        ) ?? 0;
      const totalDiamonds =
        eventProduct.subProducts?.reduce(
          (accumulator: number, currentValue: Product) => {
            return accumulator + (currentValue.diamonds ?? 0);
          },
          0
        ) ?? 0;

      eventProduct.total_price = totalPrice;
      eventProduct.total_net_price = totalPriceNet;
      eventProduct.diamonds = totalDiamonds;
      calculateTotals(state);
    },

    handleRemoveDynamicPackage: (state, action) => {
      const removeId = normalizeProductIdentifier(action.payload.identifier);
      const products = state.ShoppingCartV2?.products ?? [];

      if (!products.length) {
        state.ShoppingCartV2 = {} as any;
        return;
      }

      if (products.length === 1) {
        state.ShoppingCartV2 = {} as any;
        return;
      }

      if (!removeId) {
        return;
      }

      const indexToRemove = products.findIndex(
        (product) => normalizeProductIdentifier(product.identifier) === removeId
      );

      if (indexToRemove < 0) {
        return;
      }

      const related_guest_indexes =
        products[indexToRemove].related_guest_indexes;

      products.splice(indexToRemove, 1);
      pruneGuestIndexes(state, related_guest_indexes);
      calculateTotals(state);
    },

    removeEventTicketFromDynamicPackageCart: (state, action) => {
      const { packageIdentifier, eventIdentifier, eventTicketId } =
        action.payload;
      const allProducts: any[] = current(state).ShoppingCartV2.products ?? [];

      if (!allProducts?.length) {
        return;
      }

      const packageIndex = allProducts.findIndex(
        (product) => product.identifier === packageIdentifier
      );

      if (packageIndex < 0 || !allProducts[packageIndex]) {
        return;
      }

      const packageProduct = allProducts[packageIndex];

      // Find Event subProduct
      const eventSubProductIndex = packageProduct.subProducts?.findIndex(
        (subProduct: any) =>
          subProduct.type === MainProductType.Event &&
          subProduct.identifier === eventIdentifier
      );

      if (eventSubProductIndex === undefined || eventSubProductIndex < 0) {
        return;
      }

      const eventSubProduct = packageProduct.subProducts[eventSubProductIndex];

      // Find EventTicket within Event subProduct
      const eventTicketIndex = eventSubProduct.subProducts?.findIndex(
        (ticket: any) => ticket.id === eventTicketId
      );

      if (eventTicketIndex === undefined || eventTicketIndex < 0) {
        return;
      }

      const eventTicket = eventSubProduct.subProducts[eventTicketIndex];
      const related_guest_indexes = flatten(eventTicket.related_guest_indexes);

      // Remove the EventTicket from Event subProduct
      const updatedEventTickets = eventSubProduct.subProducts.filter(
        (ticket: any) => ticket.id !== eventTicketId
      );

      if (updatedEventTickets.length === 0) {
        // Last ticket - remove entire Event subProduct
        const nonEventSubProducts = packageProduct.subProducts.filter(
          (subProduct: any, idx: number) => idx !== eventSubProductIndex
        );

        if (
          nonEventSubProducts.length === 0 &&
          packageProduct.product_data?.isPartialDynamicPackage
        ) {
          // Partial stub with no subProducts left - remove entire DP
          const isLastProduct = allProducts.length < 2;
          if (isLastProduct) {
            state.ShoppingCartV2 = {} as any;
            return;
          }
          state.ShoppingCartV2.products = allProducts.filter(
            (product) => product.identifier !== packageIdentifier
          );
        } else {
          // Just remove the Event subProduct
          state.ShoppingCartV2.products[packageIndex].subProducts =
            nonEventSubProducts;
        }
      } else {
        // Update Event subProduct with remaining tickets
        const subProducts =
          state.ShoppingCartV2.products[packageIndex].subProducts;
        if (subProducts && subProducts[eventSubProductIndex]) {
          subProducts[eventSubProductIndex].subProducts = updatedEventTickets;
        }
      }

      // Prune the removed ticket's guests AFTER the node was removed from the
      // tree: drops those g_indexes from guests and from every
      // related_guest_indexes (package + remaining event tickets) without
      // re-indexing the survivors (sparse).
      pruneGuestIndexes(state, related_guest_indexes);

      // Recalculate totals
      const eventTicketPrice = eventTicket.total_price || 0;
      const eventTicketDiamonds = eventTicket.diamonds || 0;

      state.ShoppingCartV2.products[packageIndex].total_price -=
        eventTicketPrice;
      state.ShoppingCartV2.products[packageIndex].total_net_price -=
        eventTicketPrice;
      state.ShoppingCartV2.products[packageIndex].diamonds =
        (state.ShoppingCartV2.products[packageIndex].diamonds || 0) -
        eventTicketDiamonds;

      calculateTotals(state);
    },

    addFlightToCart: (state, action) => {
      const flight = action.payload.flights[0];
      const isBundleFlight = !!(
        action.payload.flights.length === 1 && flight.flightsInfo.flightBack
      );
      const isCombinedOneWay =
        action.payload.flights.length === 2 && !flight.flightsInfo.flightBack;
      const uuidForCombinedOneWay = generateUUID();
      const agent_commission =
        flight.flightsInfo?.agent_additional_info?.suggested_commission ?? 0;
      const agent = action.payload.agent;
      const rates = action.payload.rates;
      mergeCartExchangeRates(state, rates);

      initialStateShoppingCart(
        state,
        flight.flightsInfo.price.currency_sign,
        flight.flightsInfo.price.currency_sign,
        agent_commission,
        agent
      );
      mergeCartExchangeRates(state, rates);

      const numberOfAdults = flight.pax.adult ? Number(flight.pax.adult) : 0;
      const numberOfChildren = flight.pax.child ? Number(flight.pax.child) : 0;
      const numberOfInfants = flight.pax.infant ? Number(flight.pax.infant) : 0;
      const totalNumberOfGuests =
        numberOfAdults + numberOfChildren + numberOfInfants;

      const packageIndexTemp =
        state.ShoppingCartV2.products?.findIndex((product) => {
          return product.identifier === flight.flightsInfo.identifier;
        }) ?? 0;

      const prevGuests = state.ShoppingCartV2.guests ?? [];

      const prevGuestIndexes =
        current(state).ShoppingCartV2.products?.[packageIndexTemp]
          ?.related_guest_indexes ?? [];

      const newGuestIndexes = [
        ...Array.from(Array(totalNumberOfGuests)).map(
          (_, i) => getNextGuestIndex(prevGuests) + i
        ),
      ];

      const generateGuests = (
        pax: string,
        guestNumber: number,
        startIndex: number
      ) => {
        return Array.from(Array(guestNumber)).map((_, i) => {
          const guest: any = {
            id: '',
            g_index: startIndex + i,
            first_name: '',
            last_name: '',
            gender: '',
            type: pax,
            birthdate: null,
            passport_id: '',
            attachment: '',
          };
          flight.packageData?.settings?.guests_extra_fields &&
            flight.packageData?.settings?.guests_extra_fields.forEach(
              (field: any) => {
                guest[field.name] = '';
              }
            );

          return guest;
        });
      };

      const startIndexOfChildren =
        getNextGuestIndex(prevGuests) + numberOfAdults;
      const startIndexOfInfants = startIndexOfChildren + numberOfChildren;

      const newAdultGuests = generateGuests(
        'adult',
        numberOfAdults,
        getNextGuestIndex(prevGuests)
      );
      const newChildGuests = generateGuests(
        'child',
        numberOfChildren,
        startIndexOfChildren
      );
      const newInfantGuests = generateGuests(
        'infant',
        numberOfInfants,
        startIndexOfInfants
      );

      state.ShoppingCartV2.guests = [
        ...prevGuests,
        ...newAdultGuests,
        ...newChildGuests,
        ...newInfantGuests,
      ] as any;

      // Check If Package is already added as a product in out cart
      const isProductAlreadyAdded = state.ShoppingCartV2.products?.find(
        (product) => product.identifier === flight.flightsInfo.identifier
      );

      // if it's one way - so it will date the time of depart & arrival
      // if it's bundle way - so it will date the time of depart & arrival
      const date_start = flight.flightsInfo.flightFrom
        ? flight.flightsInfo.flightFrom[0].departure_date
        : null;

      const date_end = !flight.flightsInfo.flightBack
        ? flight.flightsInfo.flightFrom[0].arrival_date
        : flight.flightsInfo.flightBack[
            flight.flightsInfo.flightBack.length - 1
          ].arrival_date;

      const cumulativeDiamonds =
        !isBundleFlight &&
        Array.isArray(action.payload.flights) &&
        action.payload.flights.reduce(
          (accumulator: number, oneWayFlight: any) => {
            return accumulator + (oneWayFlight.flightsInfo.diamonds || 0);
          },
          0
        );

      const diamonds = isBundleFlight
        ? flight?.flightsInfo?.diamonds
        : cumulativeDiamonds;

      const total = 0;
      const mainProduct = {
        identifier: isBundleFlight
          ? flight.flightsInfo.identifier
          : isCombinedOneWay
            ? uuidForCombinedOneWay
            : flight.flightsInfo.identifier,
        type: !isBundleFlight
          ? MainProductType.oneWayFlights
          : MainProductType.Flights,
        name: flight.flightsInfo.name,
        product_data: {
          flightsInfo: {
            ...omit(flight.flightsInfo, 'flights_terms'),
            diamonds,
          },
          pax: flight.pax,
        },
        total_price: total,
        total_net_price: total,
        product_amount: 1,
        date_start: date_start,
        date_end: date_end,
        diamonds,
        ts_booking_data: flight.flightsInfo?.ts_booking_data,
      } as any;

      const isAlreadyIncludeOneWayFlight = state.ShoppingCartV2.products?.some(
        (product) => product.identifier === null
      );
      if (!isProductAlreadyAdded) {
        const prevProducts = state.ShoppingCartV2.products ?? [];
        if (
          !isBundleFlight &&
          prevProducts?.length > 0 &&
          isAlreadyIncludeOneWayFlight
        ) {
          state.ShoppingCartV2.products = [...prevProducts];
        } else {
          state.ShoppingCartV2.products = [...prevProducts, mainProduct];
        }
      }

      const { flightBack, flightFrom, flight_terms, ...flightSharedData } =
        flight.flightsInfo;

      const flightSubProducts =
        current(state).ShoppingCartV2.products?.[packageIndexTemp]?.subProducts;

      // SUB PRODUCT FLIGHTS
      const subProductFlights: any[] = flightSubProducts
        ? [...flightSubProducts]
        : [];

      !isBundleFlight &&
        action.payload.flights.map((singleFlight: any) => {
          const suitcasePrice =
            singleFlight?.flightsInfo?.flightFrom?.baggage?.suitcase_price ||
            singleFlight?.flightsInfo?.flightBack?.baggage?.suitcase_price ||
            0;

          const trollyPrice =
            singleFlight?.flightsInfo?.flightFrom?.baggage?.trolly_price ||
            singleFlight?.flightsInfo?.flightBack?.baggage?.trolly_price ||
            0;

          const calculatedPrice =
            numberOfAdults * (singleFlight.flightsInfo.price.adult ?? 0) +
            numberOfChildren * (singleFlight.flightsInfo.price.child ?? 0) +
            numberOfInfants * (singleFlight.flightsInfo.price.infant ?? 0) +
            suitcasePrice +
            trollyPrice;

          const tPrice =
            singleFlight.flightsInfo.price.total ??
            singleFlight.flightsInfo.price.grandTotal ??
            calculatedPrice;

          const legCurrency = singleFlight.flightsInfo?.price?.currency_sign;

          subProductFlights.push({
            id: singleFlight.id,
            identifier: singleFlight.flightsInfo.identifier,
            type: MainProductType.oneWayFlight,
            product_amount: 1,
            product_price: 0,
            total_price: tPrice,
            total_net_price: tPrice,
            base_currency_sign: legCurrency,
            related_guest_indexes: newGuestIndexes,
            product_data: {
              singleFlight,
              ...omit(singleFlight.flightsInfo, 'flights_terms'),
              ...singleFlight.pax,
            },
            diamonds: singleFlight.flightsInfo.diamonds,
            subProducts: [],
          });
        });

      if (flight.flightsInfo && isBundleFlight) {
        subProductFlights[0] = {
          id: flightFrom.id,
          type: MainProductType.Flight,
          product_amount: 1,
          product_price: 0,
          total_price: 0,
          total_net_price: 0,
          related_guest_indexes: newGuestIndexes,
          product_data: {
            flightFrom,
            ...flightSharedData,
            ...flight.pax,
          },
          subProducts: [],
        };

        if (flightBack) {
          subProductFlights[1] = {
            id: flightBack.id,
            type: MainProductType.Flight,
            product_amount: 1,
            product_price: 0,
            total_price: 0,
            total_net_price: 0,
            related_guest_indexes: newGuestIndexes,
            product_data: {
              flightBack,
              ...flightSharedData,
              ...flight.pax,
            },
            subProducts: [],
          };
        }
      }

      const flightPrice = flight.flightsInfo.price;
      const combinedOneWayTotal =
        !isBundleFlight && rates
          ? calcFlightsTotalUtil({
              flights: action.payload.flights.map(
                (oneWayFlight: any) => oneWayFlight.flightsInfo
              ),
              pax: flight.pax,
              rates,
            })
          : null;

      const newProductTotalPrice = isBundleFlight
        ? (flightPrice.grandTotal ??
          flightPrice.total ??
          numberOfAdults * (flightPrice.adult ?? 0) +
            numberOfChildren * (flightPrice.child ?? 0) +
            numberOfInfants * (flightPrice.infant ?? 0))
        : (combinedOneWayTotal?.total ??
          action.payload.flights.reduce(
            (accumulator: number, oneWayFlight: any) => {
              const oneWayFlightPrice = oneWayFlight.flightsInfo.price;
              const calculatedTotalPrice =
                numberOfAdults * oneWayFlightPrice.adult +
                numberOfChildren *
                  (oneWayFlightPrice.child ?? oneWayFlightPrice.adult) +
                numberOfInfants * oneWayFlightPrice.infant;
              const tPrice =
                oneWayFlightPrice.grandTotal ?? calculatedTotalPrice;
              return accumulator + tPrice;
            },
            0
          ));

      const newProductTotalDiamonds = isBundleFlight
        ? flight.flightsInfo.diamonds
        : action.payload.flights.reduce(
            (accumulator: number, oneWayFlight: any) => {
              const tDiamonds = oneWayFlight.flightsInfo.diamonds;
              return accumulator + tDiamonds;
            },
            0
          );

      const packageIndex = state.ShoppingCartV2.products.findIndex(
        (product) => {
          if (isCombinedOneWay)
            return product.identifier === uuidForCombinedOneWay;
          return product.identifier === flight.flightsInfo.identifier;
        }
      );

      const allSubProducts =
        current(state).ShoppingCartV2.products?.[packageIndex]?.subProducts;

      const oldPrice =
        allSubProducts?.reduce(
          (accumulator, currentValue) => accumulator + currentValue.total_price,
          0
        ) ?? 0;

      const oldDiamonds =
        allSubProducts?.reduce(
          (accumulator, currentValue) =>
            accumulator + (currentValue.diamonds || 0),
          0
        ) ?? 0;

      const priceOfWholePackage = newProductTotalPrice + oldPrice;
      const diamondsOfWholePackage = newProductTotalDiamonds + oldDiamonds;

      state.ShoppingCartV2.products[packageIndex].subProducts = [
        ...subProductFlights,
      ] as any;
      // Always set total_price — single one-way flights were left at 0 because
      // the original condition only covered bundle and combined-one-way cases.
      state.ShoppingCartV2.products[packageIndex].total_price =
        priceOfWholePackage;
      state.ShoppingCartV2.products[packageIndex].total_net_price =
        priceOfWholePackage;
      state.ShoppingCartV2.products[packageIndex].diamonds =
        diamondsOfWholePackage;
      state.ShoppingCartV2.products[packageIndex].base_currency_sign =
        isCombinedOneWay && combinedOneWayTotal
          ? combinedOneWayTotal.currency
          : flight.flightsInfo?.price?.currency_sign;
      state.ShoppingCartV2.products[packageIndex].related_guest_indexes = [
        ...prevGuestIndexes,
        ...newGuestIndexes,
      ];

      state.ShoppingCartV2.settings = {
        show_guest_passport: true,
      };
      calculateTotals(state);
    },

    addActivityToCart: (state, action) => {
      const existingProduct: any = state.ShoppingCartV2.products?.find(
        (product) => product.identifier === action.payload.id
      );
      let product_amount = 1;
      let total_price = parseFloat(action.payload.min_price);

      if (isEmpty(state.ShoppingCartV2)) {
        state.ShoppingCartV2 = {
          orderId: 'ORDER_ID',
          orderSecret: 'ORDER_SECRET',
        } as any;
      }

      if (existingProduct) {
        product_amount = existingProduct.product_amount + 1;
        total_price *= product_amount;
        existingProduct.product_amount = product_amount;
        existingProduct.total_price = total_price.toString();
        existingProduct.total_net_price = total_price.toString();
      } else {
        const newProduct: any = {
          identifier: action.payload.id,
          type: MainProductType.Activity,
          name: action.payload.name,
          product_amount: product_amount,
          product_price: action.payload.min_price,
          total_price: total_price.toString(),
          total_net_price: total_price.toString(),
        };
        const prevProducts = state.ShoppingCartV2.products ?? [];
        state.ShoppingCartV2.products = [...prevProducts, newProduct];
      }
    },
    handleGustInfoChange(state, action) {
      const allGuests = current(state).ShoppingCartV2.guests;
      const guestId = allGuests.findIndex((guest) => {
        return guest.g_index === action.payload.g_index;
      });
      state.ShoppingCartV2.guests[guestId] = {
        ...state.ShoppingCartV2.guests[guestId],
        ...action.payload,
      };
    },
    handleAttractionQuestionsInit(state, action) {
      state.questions = action?.payload?.data;
    },

    handleAttractionQuestiOnChange(
      state,
      action: {
        payload: {
          fieldName: string | number | (string | number)[];
          data: CustomerQuestion | ParticipantQuestion;
        };
        type: string;
      }
    ) {
      const { fieldName, data } = action.payload;
      if (!Array.isArray(fieldName)) {
        // not a real scenario but TODO:
        return;
      }
      const currState = current(state);
      const [type, ...ids] = fieldName;

      if (type === 'customer' && currState.questions.questions[type]) {
        state.questions.questions[type] = currState.questions.questions[
          type
        ].map((question: any) => (question.id === ids[0] ? data : question));
      } else if (
        type === 'participants' &&
        currState.questions.questions[type]
      ) {
        state.questions.questions[type] = currState.questions.questions[
          type
        ].map((participant: any) => {
          if (participant.id !== ids[0]) {
            return participant;
          }

          return {
            id: participant.id,
            questions: participant?.questions?.map((question: any) =>
              question.id === ids[1] ? data : question
            ),
          };
        });
      }
    },
    setCompleteShoppingCart(state, action) {
      if (action.payload) {
        state.ShoppingCartV2 = action.payload;
      }
    },
    handleRemoveRoom(state, action) {
      const related_guest_indexes = action.payload.related_guest_indexes;
      const roomUniqueIdentifier = action.payload?.product_data?.book_hash;
      // Prefer the per-instance uuid so duplicate rooms (identical book_hash)
      // are removed one at a time. Falls back to book_hash for rooms created
      // before uuids existed (old persisted carts) and package rooms.
      const removeUuid = action.payload?.uuid;

      const isPackage = !!action.payload.packageId;
      const identifier = normalizeProductIdentifier(action.payload.identifier);
      const mainProductIndex = state.ShoppingCartV2.products.findIndex(
        (product) =>
          normalizeProductIdentifier(product.identifier) === identifier
      );
      const wholeHotel = state.ShoppingCartV2.products[
        mainProductIndex
      ].subProducts?.find((p) => p.type === MainProductType.Hotel);

      const rooms = isPackage
        ? state.ShoppingCartV2.products[mainProductIndex].subProducts?.find(
            (p) => p.type === MainProductType.Hotel
          )?.subProducts
        : state.ShoppingCartV2.products[mainProductIndex].subProducts;

      // Remove only the clicked room instance. Guest indexes are pruned later
      // by pruneGuestIndexes (sparse: surviving rooms keep their g_indexes).
      const filteredRooms = rooms?.filter((room) => {
        // Prefer the per-instance uuid so duplicate rooms (identical book_hash)
        // are removed one at a time. Falls back to book_hash for legacy carts.
        if (removeUuid && (room as any)?.uuid) {
          return (room as any).uuid !== removeUuid;
        }
        return room?.product_data?.book_hash !== roomUniqueIdentifier;
      });

      const isLastProduct = state.ShoppingCartV2.products.length === 1;

      // Fix: Properly check if filteredRooms is empty or has no Room-type items
      const isLastRoom =
        !filteredRooms ||
        filteredRooms.length === 0 ||
        !filteredRooms.some((room) => room.type === MainProductType.Room);

      if (isLastRoom && isLastProduct) {
        state.ShoppingCartV2 = {} as any;
      } else if (isLastRoom) {
        const related_guest_indexes =
          state.ShoppingCartV2.products[mainProductIndex]
            ?.related_guest_indexes;
        state.ShoppingCartV2.products.splice(mainProductIndex, 1);
        pruneGuestIndexes(state, related_guest_indexes);
        calculateTotals(state);
      } else {
        // Fix: Safety check for hotels - if filteredRooms is empty, remove the hotel product
        if (!isPackage && (!filteredRooms || filteredRooms.length === 0)) {
          const related_guest_indexes =
            state.ShoppingCartV2.products[mainProductIndex]
              ?.related_guest_indexes;
          state.ShoppingCartV2.products.splice(mainProductIndex, 1);
          pruneGuestIndexes(state, related_guest_indexes);
          calculateTotals(state);
          return;
        }

        if (isPackage) {
          // Mutate on the Immer draft (not current(state) snapshots) so
          // pruneGuestIndexes can mutate related_guest_indexes on survivors.
          if (wholeHotel) {
            wholeHotel.subProducts = filteredRooms as any;
          }
        } else {
          state.ShoppingCartV2.products[mainProductIndex].subProducts =
            filteredRooms as any;
        }

        const totalPrice =
          filteredRooms?.reduce(
            (accumulator: number, currentValue: Product) => {
              return accumulator + currentValue.total_price;
            },
            0
          ) ?? 0;
        const totalPriceNet =
          filteredRooms?.reduce(
            (accumulator: number, currentValue: Product) => {
              return accumulator + currentValue.total_net_price;
            },
            0
          ) ?? 0;
        const totalDiamonds =
          filteredRooms?.reduce(
            (accumulator: number, currentValue: Product) => {
              return accumulator + (currentValue.diamonds ?? 0);
            },
            0
          ) ?? 0;
        state.ShoppingCartV2.products[mainProductIndex].total_price =
          totalPrice;
        state.ShoppingCartV2.products[mainProductIndex].total_net_price =
          totalPriceNet;
        state.ShoppingCartV2.products[mainProductIndex].diamonds =
          totalDiamonds;

        // Prune AFTER the deleted room node is removed from the tree so only
        // surviving guests/indexes remain (sparse: no re-indexing).
        pruneGuestIndexes(state, related_guest_indexes);

        calculateTotals(state);
      }
    },
    handleAdjustGuestIndexes(state, action) {
      const related_guest_indexes = flatten(
        action.payload.related_guest_indexes
      ) as number[];
      if (related_guest_indexes.length === 0) {
        // return;
      }

      const deductAmount = related_guest_indexes.length;
      const firstGuestIndex = Math.min(...related_guest_indexes);
      const recursiveUpdate = (obj: any) => {
        if (typeof obj !== 'object' || obj === null) {
          return;
        }
        if (Array.isArray(obj.related_guest_indexes)) {
          obj.related_guest_indexes = obj.related_guest_indexes
            .filter((index: number) => {
              return !related_guest_indexes.includes(index);
            })
            .map((indexes: any) => {
              if (Array.isArray(indexes)) {
                return indexes.map((index: number) => {
                  if (index >= firstGuestIndex) {
                    return index - deductAmount;
                  }
                  return index;
                });
              } else if (typeof indexes === 'number') {
                if (indexes >= firstGuestIndex) {
                  return indexes - deductAmount;
                }
                return indexes;
              }
              return indexes;
            });
        }
        Object.values(obj).forEach((value) => recursiveUpdate(value));
      };

      recursiveUpdate(state);
      // state.ShoppingCartV2?.products?.forEach((product) =>
      //   recursiveUpdate(product)
      // );
    },

    handleRefreshReusedGuestIndex(state, action) {
      const {
        product,
        relatedGuestIndex,
      }: { product: Product; relatedGuestIndex: number } = action.payload;
      // Validate input parameters
      if (!product || typeof relatedGuestIndex !== 'number') {
        return;
      }
      // Add new element to the order guests array and update product related_guest_indexes
      const currentGuests = current(state).ShoppingCartV2.guests;
      const originalGuest = currentGuests.find(
        (guest) => guest.g_index === relatedGuestIndex
      );
      // Validate that the original guest exists
      if (!originalGuest) {
        return;
      }
      const newRelatedGuestIndex = (): number => {
        // Get all existing g_index values
        const existingIndexes = currentGuests.map((guest) => guest.g_index);
        // Early return if no guests exist
        if (existingIndexes.length === 0) {
          return 0;
        }

        // simply set new guest index to the max index + 1
        return Math.max(...existingIndexes) + 1;
        // // Sort indexes for more efficient gap finding
        // const sortedIndexes = [...existingIndexes].sort((a, b) => a - b);
        // // Find the first available gap in the sequence
        // for (let i = 0; i < sortedIndexes.length; i++) {
        //   if (i !== sortedIndexes[i]) {
        //     return i;
        //   }
        // }
        // // If no gap found, return the next number in sequence
        // return sortedIndexes[sortedIndexes.length - 1] + 1;
      };
      const newGuestIndex = newRelatedGuestIndex();
      const newGuest = {
        ...originalGuest,
        g_index: newGuestIndex,
      };
      state.ShoppingCartV2.guests = [...currentGuests, newGuest];
      // update the guests array done.

      // now update the product related_guest_indexes:
      const currentProducts = current(state).ShoppingCartV2.products;

      const recursiveUpdateOfProductRelatedGuestIndexes = (
        products: any[],
        forceUpdate: boolean = false
      ): any[] => {
        return products.map((obj) => {
          if (typeof obj !== 'object' || obj === null) {
            return obj;
          }

          let updatedObj = { ...obj };

          // Update if this is the target product or its parent,
          // and also update it's every subproducts related_guest_indexes
          if (
            (obj?.id === product.id ||
              (obj?.subProducts &&
                obj?.subProducts?.some((el: any) => el?.id === product.id)) ||
              forceUpdate) &&
            Array.isArray(obj.related_guest_indexes)
          ) {
            let alreadyUpdated = false;
            const updatedRelatedGuestIndexes = obj.related_guest_indexes.map(
              (g_index: number) => {
                if (Array.isArray(g_index)) {
                  return g_index.map((ii) => {
                    if (!alreadyUpdated && ii === relatedGuestIndex) {
                      alreadyUpdated = true;
                      return newGuestIndex;
                    }
                    return ii;
                  });
                } else {
                  if (!alreadyUpdated && g_index === relatedGuestIndex) {
                    alreadyUpdated = true;
                    return newGuestIndex;
                  }
                  return g_index;
                }
              }
            );

            updatedObj.related_guest_indexes = updatedRelatedGuestIndexes;
          }

          // Recursively process subproducts if they exist
          if (
            updatedObj?.subProducts &&
            Array.isArray(updatedObj?.subProducts)
          ) {
            updatedObj.subProducts =
              recursiveUpdateOfProductRelatedGuestIndexes(
                updatedObj.subProducts,
                forceUpdate || obj?.id === product.id
              );
          }

          return updatedObj;
        });
      };

      // update product related_guest_indexes done.
      state.ShoppingCartV2.products =
        currentProducts?.length > 0
          ? recursiveUpdateOfProductRelatedGuestIndexes(currentProducts, false)
          : [];
    },

    handleRemoveFlightBundle(state, action) {
      const removeId = normalizeProductIdentifier(action.payload.identifier);
      const products = state.ShoppingCartV2?.products ?? [];

      if (!products.length) {
        return;
      }

      if (products.length === 1) {
        state.ShoppingCartV2 = {} as any;
        return;
      }

      if (!removeId) {
        console.warn(
          'handleRemoveFlightBundle: missing identifier on payload',
          action.payload
        );
        return;
      }

      const indexToRemove = products.findIndex(
        (product) => normalizeProductIdentifier(product.identifier) === removeId
      );

      if (indexToRemove < 0) {
        console.warn('handleRemoveFlightBundle: product not found', removeId);
        return;
      }

      const related_guest_indexes =
        action.payload.related_guest_indexes ??
        products[indexToRemove].related_guest_indexes;

      removeTopLevelCartProduct(state, removeId, related_guest_indexes);
    },

    handleCustomerInfoChange(state, action) {
      if (state?.ShoppingCartV2) {
        state.ShoppingCartV2.customerInfo = {
          ...state.ShoppingCartV2.customerInfo,
          ...action.payload,
        };
      }
    },
    handleAddBaggageToShoppingCart(state, action) {
      const isOneWayFlight = action?.payload?.isOneWayFlight;
      const isRoundTrip = action?.payload?.isRoundTrip;

      let flightsArray = getFlightsFromProducts(
        state.ShoppingCartV2,
        action.payload.staticI
      );

      const selectedFlight = flightsArray?.[action.payload.direction];

      const existedSubProduct: any = {
        ...selectedFlight?.subProducts?.find(
          (product: any) => product.type === action.payload.type
        ),
      };
      const calculateSubProductsTotal = (products: any) => {
        let total = 0;
        let netTotal = 0;
        products.forEach((product: any) => {
          product.subProducts?.forEach((subProduct: any) => {
            total += subProduct.total_price;
            netTotal += subProduct.total_net_price;
          });
        });
        return { total, netTotal };
      };

      const updateTotalPrice = (
        productsArray: any,
        totalPrice: number,
        prevTotalPrice: number,
        prevTotalPriceNet: number,
        totalPriceNet: number
      ) => {
        if (isOneWayFlight) {
          productsArray[action.payload.direction].total_price =
            productsArray[action.payload.direction].total_price +
            +totalPrice -
            prevTotalPrice;
          productsArray[action.payload.direction].total_net_price =
            productsArray[action.payload.direction].total_net_price +
            +totalPriceNet -
            prevTotalPriceNet;

          // Only propagate bags to the bundle line when it already holds a
          // converted total (> 0). When it's 0, collectCartBillableParts falls
          // through to the leg sub-products (updated above), so the cart total
          // is already correct and we must not overwrite the bundle with the
          // bag-only delta (which would drop the flight price from the total).
          const bundleCurrentTotal =
            state.ShoppingCartV2.products[action.payload.staticI].total_price;
          if (bundleCurrentTotal > 0) {
            state.ShoppingCartV2.products[action.payload.staticI].total_price =
              bundleCurrentTotal + totalPrice - prevTotalPrice;
            state.ShoppingCartV2.products[
              action.payload.staticI
            ].total_net_price =
              state.ShoppingCartV2.products[action.payload.staticI]
                .total_net_price +
              totalPriceNet -
              prevTotalPriceNet;
          }
        } else {
          state.ShoppingCartV2.products[action.payload.staticI].total_price =
            state.ShoppingCartV2.products[action.payload.staticI].total_price +
            totalPrice -
            prevTotalPrice;
          state.ShoppingCartV2.products[
            action.payload.staticI
          ].total_net_price =
            state.ShoppingCartV2.products[action.payload.staticI]
              .total_net_price +
            totalPriceNet -
            prevTotalPriceNet;
        }
      };

      const allSubProductsWithoutLatestProduct =
        selectedFlight?.subProducts?.filter(
          (product: any) => product.type !== action.payload.type
        ) ?? [];

      if (!isEmpty(existedSubProduct)) {
        const existingRelatedGuests =
          existedSubProduct.related_guest_indexes.filter(
            (guest: number) => guest !== action.payload.relatedGuestIndex
          );

        existedSubProduct.related_guest_indexes = [
          ...existingRelatedGuests,
          ...Array(action.payload.e).fill(action.payload.relatedGuestIndex),
        ];

        existedSubProduct.product_amount = [
          ...existingRelatedGuests,
          ...Array(action.payload.e).fill(action.payload.relatedGuestIndex),
        ].length;

        existedSubProduct.total_price =
          existedSubProduct.related_guest_indexes.length * action.payload.price;
        existedSubProduct.total_net_price =
          existedSubProduct.related_guest_indexes.length *
          action.payload.netPrice;

        let productsArray = getFlightsFromProducts(
          state.ShoppingCartV2,
          action.payload.staticI
        );

        if (productsArray) {
          const { total: prevTotalPrice, netTotal: prevTotalPriceNet } =
            calculateSubProductsTotal(productsArray);

          productsArray[action.payload.direction].subProducts =
            action.payload.e > 0 ||
            existedSubProduct.related_guest_indexes.length > 0
              ? [
                  ...allSubProductsWithoutLatestProduct,
                  existedSubProduct as any,
                ]
              : [...allSubProductsWithoutLatestProduct];

          const { total: totalPrice, netTotal: totalPriceNet } =
            calculateSubProductsTotal(productsArray);

          updateTotalPrice(
            productsArray,
            totalPrice,
            prevTotalPrice,
            prevTotalPriceNet,
            totalPriceNet
          );
        }

        calculateTotals(state);
        return;
      }

      const createdSubProduct = {
        type: action.payload.type,
        product_price: action.payload.price,
        related_guest_indexes: Array(action.payload.e).fill(
          action.payload.relatedGuestIndex
        ),
        product_data: {
          is_round_trip: isRoundTrip,
        },
        product_amount: Array(action.payload.e).fill(
          action.payload.relatedGuestIndex
        ).length,
        total_price: action.payload.e * action.payload.price,
        total_net_price: action.payload.e * action.payload.netPrice,
      };

      let productsArray = getFlightsFromProducts(
        state.ShoppingCartV2,
        action.payload.staticI
      );
      if (productsArray) {
        const { total: prevTotalPrice, netTotal: prevTotalPriceNet } =
          calculateSubProductsTotal(productsArray);

        productsArray[action.payload.direction].subProducts = [
          ...allSubProductsWithoutLatestProduct,
          action.payload.e > 0 ? (createdSubProduct as any) : {},
        ];

        const { total: totalPrice, netTotal: totalPriceNet } =
          calculateSubProductsTotal(productsArray);
        updateTotalPrice(
          productsArray,
          totalPrice,
          prevTotalPrice,
          prevTotalPriceNet,
          totalPriceNet
        );
      }
      calculateTotals(state);
    },
    setWholeCart(state, action) {
      //exchange_rates is a client-side siteConfig snapshot, not part of any API
      //payload — replacing the cart wholesale (attach hydration) would drop it
      //and silently degrade every total to an unconverted raw sum
      const previousRates = state.ShoppingCartV2?.exchange_rates;
      state.ShoppingCartV2 = action.payload ?? ({} as ShoppingCartV2);
      if (!state.ShoppingCartV2.exchange_rates && previousRates) {
        state.ShoppingCartV2.exchange_rates = previousRates;
      }
    },

    /** Seed/refresh the cart's siteConfig.rates snapshot outside an
     *  add-to-cart action (attach mode hydrates the cart from the order API,
     *  which carries no rates). */
    setCartExchangeRates(state, action) {
      mergeCartExchangeRates(state, action.payload);
    },
    addCommissionByPercent(state) {
      if (
        state.agent_commission &&
        state.agent_commission.type === CommissionType.Percentage
      ) {
        const recursiveUpdate = (obj: any) => {
          if (Array.isArray(obj)) {
            obj.forEach((item) => recursiveUpdate(item));
          } else if (typeof obj === 'object' && obj !== null) {
            if ('total_price' in obj && typeof obj.total_price === 'number') {
              // obj.total_price = Math.ceil(
              obj.total_price = Number(
                obj.total_net_price /
                  (1 - Number(state?.agent_commission?.percentage ?? 0) / 100)
              );
            }
            Object.values(obj).forEach((value) => recursiveUpdate(value));
          }
        };
        recursiveUpdate(state);
      }
    },

    addCommissionByPerPerson(state) {
      const flatValue = Number(state.agent_commission.per_pax);
      const adultAndChildGuests = current(state)
        .ShoppingCartV2.guests.filter(
          (guest: any) => guest.type === 'adult' || guest.type === 'child'
        )
        .map((g) => g.g_index);

      // ProductType.ATTRACTION
      let amountOfAttractions = 0;
      let amountOfAttractionParticipants = 0;
      current(state).ShoppingCartV2.products.forEach((prod) => {
        if (prod.type === MainProductType.Attraction) {
          amountOfAttractions += 1;
          if (prod.subProducts) {
            prod.subProducts.forEach((attTicket) => {
              const unitOptions =
                attTicket?.product_data?.productDetails?.availability
                  ?.unitOptions;
              if (unitOptions?.length) {
                unitOptions.forEach((unit: UnitOption) => {
                  if (unit?.unitQuantity) {
                    amountOfAttractionParticipants += unit?.unitQuantity;
                  }
                });
              }
            });
          }
        }
      });

      // Use Number.isFinite (not truthiness) so a per-pax of 0 is honored: 0 is a
      // valid profit meaning "clear the markup", and the reset below
      // (total_price = total_net_price + 0) is exactly how we bill at net. A
      // truthiness guard would skip this and leave the previous commission behind.
      if (
        Number.isFinite(flatValue) &&
        state.agent_commission.type === CommissionType.PerPax
      ) {
        const recursiveUpdate = (obj: any) => {
          if (Array.isArray(obj)) {
            obj.forEach((item) => recursiveUpdate(item));
          } else if (typeof obj === 'object' && obj !== null) {
            if (
              'total_price' in obj &&
              'related_guest_indexes' in obj &&
              typeof obj.total_price === 'number'
            ) {
              const adultsOnlyGuests =
                obj.related_guest_indexes?.filter((g_index: string) => {
                  return adultAndChildGuests.includes(g_index);
                }) ?? [];
              if (obj.total_price !== 0) {
                // obj.total_price =
                //   obj.total_net_price + flatValue * adultsOnlyGuests.length;
                if (amountOfAttractions < 1) {
                  obj.total_price =
                    obj.total_net_price + flatValue * adultsOnlyGuests.length;
                } else {
                  obj.total_price =
                    obj.total_net_price +
                    flatValue *
                      (adultsOnlyGuests.length -
                        amountOfAttractions +
                        amountOfAttractionParticipants);
                }
              }
              if (
                obj.type == MainProductType.Flight ||
                obj.type == MainProductType.Suitcase ||
                obj.type == MainProductType.Attraction ||
                obj.type == MainProductType.AttractionTicket ||
                obj.type == MainProductType.Trolly
              ) {
                obj.total_price = obj.total_net_price;
              }
            }
            Object.values(obj).forEach((value) => recursiveUpdate(value));
          }
        };
        recursiveUpdate(state);
      }

      // Mixed-currency Profit-Per-Person commission. The BE adds the per-pax share
      // to each priced line RAW in that line's own currency, then totals by summing
      // the lines (converting each to the base currency). The flat walk above already
      // does the raw per-line add correctly for simple products, but it is
      // currency-blind for the two products whose commission is *distributed* across
      // sub-lines of differing currencies:
      //   • one-way flights   → per_pax × pax split equally across the N legs
      //   • dynamic packages  → per_pax × pax split 80% flight / 20% rooms
      // For those we recompute the billable (container) line as a currency-aware
      // aggregate so it matches the BE after refresh-rates. The order total is then
      // the currency-aware SUM of the priced lines (mirrors the BE's
      // calculateTotalPricesForOrder) — except when attractions are present, which
      // keep their existing participant-based handling untouched.
      const rates = current(state).ShoppingCartV2?.exchange_rates;
      const cartCurrencySign = current(state).ShoppingCartV2?.currency_sign;
      let distributedFlatContribution = 0;
      let distributedCurrencyCommission = 0;
      let hasDistributedAdjustment = false;

      if (
        rates &&
        Number.isFinite(flatValue) &&
        state.agent_commission.type === CommissionType.PerPax
      ) {
        const snapshotProducts = current(state).ShoppingCartV2.products ?? [];

        snapshotProducts.forEach((product, pIdx) => {
          const isOneWay = product.type === MainProductType.oneWayFlights;
          const isDynamicPackage =
            product.type === MainProductType.DynamicPackage;
          if (!isOneWay && !isDynamicPackage) {
            return;
          }
          if (isOneWay && !product.subProducts?.length) {
            return;
          }
          const productPax = (product.related_guest_indexes ?? []).filter(
            (g_index) => adultAndChildGuests.includes(g_index)
          ).length;
          if (!productPax) {
            return;
          }

          const parentCurrency =
            getCartLineCurrency(product, cartCurrencySign) ?? cartCurrencySign;

          // Currency-aware commission aggregate in the container's own currency
          // (drives the billable line) and the per-leaf raw shares for one-way.
          let parentTotalConverted = 0;
          if (isOneWay) {
            const breakdown = computeOneWayPerPaxCommission({
              product,
              perPax: flatValue,
              pax: productPax,
              rates,
              targetCurrency: parentCurrency,
              cartCurrencySign,
            });
            parentTotalConverted = breakdown.totalConverted;
            // BE-shaped per-leg value: leg net + raw share, in the leg's currency.
            const draftProduct = state.ShoppingCartV2.products[pIdx];
            breakdown.legs.forEach((legBreakdown, lIdx) => {
              const draftLeg = draftProduct.subProducts?.[lIdx];
              if (!draftLeg) {
                return;
              }
              const legNet =
                Number(product.subProducts?.[lIdx]?.total_net_price) || 0;
              draftLeg.total_price = legNet + legBreakdown.rawShare;
            });
          } else {
            parentTotalConverted = computeDynamicPackagePerPaxCommission({
              product,
              perPax: flatValue,
              pax: productPax,
              rates,
              targetCurrency: parentCurrency,
              cartCurrencySign,
            }).totalConverted;
          }

          // Billable (container) line: net + currency-aware sum of the shares.
          const parentNet = Number(product.total_net_price) || 0;
          state.ShoppingCartV2.products[pIdx].total_price = Math.ceil(
            parentNet + parentTotalConverted
          );

          // Order-total contribution, expressed in the cart's display currency.
          const cartContribution = isOneWay
            ? computeOneWayPerPaxCommission({
                product,
                perPax: flatValue,
                pax: productPax,
                rates,
                targetCurrency: cartCurrencySign,
                cartCurrencySign,
              }).totalConverted
            : computeDynamicPackagePerPaxCommission({
                product,
                perPax: flatValue,
                pax: productPax,
                rates,
                targetCurrency: cartCurrencySign,
                cartCurrencySign,
              }).totalConverted;
          distributedCurrencyCommission += cartContribution;
          distributedFlatContribution += flatValue * productPax;
          hasDistributedAdjustment = true;
        });
      }

      // Order total.
      if (rates && amountOfAttractions < 1) {
        // No attractions → the canonical currency-aware sum of the priced lines,
        // mirroring the BE. Each line now carries its per-pax share in its own
        // currency (simple products via the flat walk above; one-way / dynamic
        // packages via the aggregates set above), so the converted sum equals the
        // BE total after refresh-rates.
        const { gross } = calculateCartTotalsUtil({
          products: current(state).ShoppingCartV2.products,
          cartCurrencySign,
          rates,
        });
        state.ShoppingCartV2.total_price = gross.total;
      } else {
        // Attractions present (keep their participant-based handling) or no rates
        // (degrade to today's flat behavior). Still currency-correct the one-way /
        // dynamic-package portion when we computed it above.
        const flatOrderCommission =
          amountOfAttractions < 1
            ? adultAndChildGuests.length * flatValue
            : (adultAndChildGuests.length -
                amountOfAttractions +
                amountOfAttractionParticipants) *
              flatValue;

        if (hasDistributedAdjustment) {
          state.ShoppingCartV2.total_price = Math.ceil(
            state.ShoppingCartV2.total_net_price +
              flatOrderCommission -
              distributedFlatContribution +
              distributedCurrencyCommission
          );
        } else {
          state.ShoppingCartV2.total_price =
            state.ShoppingCartV2.total_net_price + flatOrderCommission;
        }
      }
    },

    agentCommissionPercent(state, action) {
      state.agent_commission.percentage = action.payload;
      state.agent_commission.type = CommissionType.Percentage;
    },
    agentCommissionPerPerson(state, action) {
      state.agent_commission.per_pax = action.payload;
      state.agent_commission.type = CommissionType.PerPax;
    },
    setCommission(state, action) {
      state.agent_commission = action.payload;
    },
    setCustomerInfo(state, action) {
      state.customerInfo = action.payload;
    },
    handleOrderSecret(state, action) {
      state.ShoppingCartV2.orderSecret = action.payload.order_secret;
    },
    clearShoppingCart(state) {
      state.ShoppingCartV2 = {} as any;
    },
    clearCustomerInfo(state) {
      state.customerInfo = {
        first_name: '',
        last_name: '',
        phone: '',
        email: '',
        comment: '',
        order_secret: '',
        customer_secret: '',
      };
    },
    updateOrderInfo: (state, action) => {
      state.ShoppingCartV2.orderSecret = action.payload.orderSecret;
      state.ShoppingCartV2.orderId = action.payload.orderId;
    },
    updateOrderTransactionId: (state, action) => {
      state.paymentFormData.transactionId = action.payload.transaction_id;
    },
    updatePaymentRetriesCount: (state, action) => {
      state.paymentFormData.paymentRetries = action.payload.paymentRetries;
    },
    updateOrderPriceOption: (state, action) => {
      state.orderPriceOption = action.payload;
    },
    setAttachToOrderContext(state, action) {
      state.attachToOrder = action.payload;
    },
    clearAttachToOrderContext(state) {
      state.attachToOrder = null;
      state.attachOrderSnapshot = null;
    },
    setAttachOrderSnapshot(state, action) {
      state.attachOrderSnapshot = action.payload;
    },
    /** Keep the cart = existing order + newly selected products.
     *  Product-selection reducers may reset the cart (they build a fresh cart
     *  when no orderId is present); this merge restores the order around the
     *  new selection: new guests are re-indexed AFTER the order's guests and
     *  the new products' related_guest_indexes are remapped accordingly.
     *  Idempotent — no-op while the cart still holds the order products. */
    mergeAttachOrderCart(state) {
      const snap = state.attachOrderSnapshot;
      if (!state.attachToOrder || !snap?.products?.length) {
        return;
      }
      const cart = state.ShoppingCartV2 ?? ({} as any);
      const cartProducts: any[] = cart.products ?? [];
      const hasOrderProducts = cartProducts.some((p: any) => p.id);

      if (hasOrderProducts) {
        //hydration intact (or already merged) — keep the snapshot in sync so
        //a later cart reset can restore the new selection too (a new selection
        //may also be a subProduct without id under an existing order product)
        if (
          cartProducts.some(
            (p: any) => !p.id || p.subProducts?.some((sp: any) => !sp.id)
          )
        ) {
          state.attachOrderSnapshot = JSON.parse(JSON.stringify(cart));
        }
        return;
      }

      if (!cartProducts.length) {
        //cart was cleared with nothing selected — restore the order view
        state.ShoppingCartV2 = {
          ...JSON.parse(JSON.stringify(snap)),
          isSaved: true,
        };
        return;
      }

      //cart holds ONLY the new selection — merge the order back around it
      const snapCopy = JSON.parse(JSON.stringify(snap));
      const snapGuests: any[] = snapCopy.guests ?? [];
      const nextIndex = snapGuests.reduce(
        (max: number, g: any) => Math.max(max, Number(g.g_index) + 1),
        0
      );
      const newGuests: any[] = (cart.guests ?? []).filter((g: any) => !g.id);
      const indexMap = new Map<number, number>();
      newGuests.forEach((g: any, i: number) => {
        indexMap.set(Number(g.g_index), nextIndex + i);
      });
      const shiftedGuests = newGuests.map((g: any) => ({
        ...g,
        g_index: indexMap.get(Number(g.g_index)),
      }));
      const remapIndexes = (node: any) => {
        const rgi = node?.related_guest_indexes;
        if (rgi?.length) {
          const isNested = Array.isArray(rgi[0]);
          const groups: any[][] = isNested ? rgi : [rgi];
          const mapped = groups.map((group) =>
            group.map((i: any) =>
              indexMap.has(Number(i)) ? indexMap.get(Number(i)) : i
            )
          );
          node.related_guest_indexes = isNested ? mapped : mapped[0];
        }
        node?.subProducts?.forEach(remapIndexes);
      };
      cartProducts.forEach(remapIndexes);

      state.ShoppingCartV2 = {
        ...snapCopy,
        isSaved: true,
        products: [...(snapCopy.products ?? []), ...cartProducts],
        guests: [...snapGuests, ...shiftedGuests],
      };
      calculateTotals(state);
      state.attachOrderSnapshot = JSON.parse(
        JSON.stringify(state.ShoppingCartV2)
      );
    },
    /** Replace flow — point the NEW product's guest slots at the
     *  replaced product's EXISTING guests (matched by guest type), so the
     *  checkout forms open prefilled and the BE reuses the guest rows
     *  instead of duplicating them. Extra seats (more pax than the replaced
     *  product had) keep their freshly created empty guest slots. Idempotent:
     *  slots already pointing at existing guests are left alone. */
    relinkReplacementProductGuests(state) {
      const replacedId = Number(
        state.attachToOrder?.replaced_order_product_id
      );
      if (!replacedId) {
        return;
      }
      const products: any[] = state.ShoppingCartV2.products ?? [];
      const guests: any[] = state.ShoppingCartV2.guests ?? [];

      const findNode = (nodes: any[]): any => {
        for (const node of nodes ?? []) {
          if (Number(node?.id) === replacedId) return node;
          const found = findNode(node?.subProducts);
          if (found) return found;
        }
        return null;
      };
      const replaced = findNode(products);
      // New selection = the nodes the agent just added (no order-product id).
      // A new node may be a top-level product OR a room nested under an
      // existing (id-bearing) hotel, so collect new nodes at any depth.
      const newNodes: any[] = [];
      const collectNew = (nodes: any[]) => {
        for (const node of nodes ?? []) {
          if (!node.id && !node.product_status) newNodes.push(node);
          collectNew(node.subProducts);
        }
      };
      collectNew(products);
      if (!replaced || !newNodes.length) {
        return;
      }

      const guestByIndex = (i: any) =>
        guests.find((g) => Number(g.g_index) === Number(i));
      const flattenIndexes = (rgi: any): any[] =>
        Array.isArray(rgi?.[0]) ? rgi.flat() : rgi ?? [];

      //source guests of the replaced product, queued per guest type
      const sourceQueues: Record<string, number[]> = {};
      flattenIndexes(replaced.related_guest_indexes).forEach((i: any) => {
        const guest = guestByIndex(i);
        if (!guest) return;
        const type = String(guest.type);
        if (!sourceQueues[type]) sourceQueues[type] = [];
        sourceQueues[type].push(Number(i));
      });

      const orphanedIndexes = new Set<number>();
      const relinkNode = (node: any) => {
        const rgi = node?.related_guest_indexes;
        if (rgi?.length) {
          const isNested = Array.isArray(rgi[0]);
          const groups: any[][] = isNested ? rgi : [rgi];
          const newGroups = groups.map((group) =>
            group.map((idx: any) => {
              const guest = guestByIndex(idx);
              //slot already bound to an existing order guest — leave it
              if (!guest || guest.id) return idx;
              const queue = sourceQueues[String(guest.type)];
              if (queue?.length) {
                orphanedIndexes.add(Number(idx));
                return queue.shift();
              }
              //no matching source guest — keep the empty slot for the agent
              return idx;
            })
          );
          node.related_guest_indexes = isNested ? newGroups : newGroups[0];
        }
        node?.subProducts?.forEach(relinkNode);
      };
      newNodes.forEach(relinkNode);

      //drop the auto-created empty guests whose slots were re-pointed and
      //that no product references anymore
      if (orphanedIndexes.size) {
        const referenced = new Set<number>();
        const collect = (node: any) => {
          flattenIndexes(node?.related_guest_indexes).forEach((i: any) =>
            referenced.add(Number(i))
          );
          node?.subProducts?.forEach(collect);
        };
        products.forEach(collect);
        state.ShoppingCartV2.guests = guests.filter(
          (g) =>
            g.id ||
            !orphanedIndexes.has(Number(g.g_index)) ||
            referenced.has(Number(g.g_index))
        );
      }
    },
  },
});

export const {
  addPackageToCart,
  addDynamicPackageToCart,
  addTicketToDynamicPackage,
  updateInfants,
  addActivityToCart,
  handleGustInfoChange,
  handleAttractionQuestionsInit,
  handleAttractionQuestiOnChange,
  setCompleteShoppingCart,
  handleCustomerInfoChange,
  handleRemoveRoom,
  addFlightToCart,
  handleAddBaggageToShoppingCart,
  addHotelToCart,
  addAttractionToCart,
  removeAttractionsFromCart,
  addEventToCart,
  removeEventTicketFromCart,
  removeEventTicketFromDynamicPackageCart,
  handleRemoveDynamicPackage,
  setWholeCart,
  setCartExchangeRates,
  addCommissionByPercent,
  addCommissionByPerPerson,
  agentCommissionPercent,
  agentCommissionPerPerson,
  setCustomerInfo,
  setCommission,
  setAttachToOrderContext,
  clearAttachToOrderContext,
  setAttachOrderSnapshot,
  mergeAttachOrderCart,
  relinkReplacementProductGuests,
  handleRemoveFlightBundle,
  clearCustomerInfo,
  clearShoppingCart,
  handleOrderSecret,
  updateOrderInfo,
  updateOrderTransactionId,
  updatePaymentRetriesCount,
  handleAdjustGuestIndexes,
  handleRefreshReusedGuestIndex,
  updateOrderPriceOption,
  applyOrderProductsFromApi,
} = shoppingCartSlice.actions;

type ShoppingCartV2SliceState = ReturnType<typeof shoppingCartSlice.reducer>;

/**
 * Attach/replace mode invariant: while the live cart still holds the hydrated
 * order, `attachOrderSnapshot` mirrors it (order + the agent's current
 * selection). `mergeAttachOrderCart` restores the cart from that snapshot
 * whenever a product-selection flow resets it, so a snapshot still holding a
 * product the agent has REMOVED would resurrect it on the next reset.
 *
 * Syncing here rather than inside each remove reducer covers every cart
 * mutation — including sub-product removals (a room dropped from an existing
 * hotel), which leave `products.length` unchanged and therefore never trigger
 * the merge watcher in useLoadOrderAttachContext.
 *
 * Skipped while the cart holds only a fresh selection (no order products):
 * there the snapshot is the only remaining copy of the order.
 */
const shoppingCartV2Reducer = (
  state: ShoppingCartV2SliceState | undefined,
  action: AnyAction
): ShoppingCartV2SliceState => {
  const next = shoppingCartSlice.reducer(state, action);
  if (
    next === state ||
    !next?.attachToOrder ||
    !next?.attachOrderSnapshot ||
    state?.ShoppingCartV2?.products === next?.ShoppingCartV2?.products
  ) {
    return next;
  }
  const products: any[] = next.ShoppingCartV2?.products ?? [];
  if (!products.some((product: any) => product?.id)) {
    return next;
  }
  return {
    ...next,
    attachOrderSnapshot: JSON.parse(JSON.stringify(next.ShoppingCartV2)),
  };
};

export default shoppingCartV2Reducer;
